import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './SuperMarket.css';

function Stationary() {
  const [categories] = useState({
    
      "Stationary": [

    { "name": "Parker Vector CT Fountain Pen", "price": 576 },
  { "name": "Pentonic Ball Point Pen Tumbler Pack", "price": 500 },
  { "name": "Parker Frontier Rollerball Pen", "price": 676 },
  { "name": "Wynhard Alcohol Markers Set", "price": 738 },
  { "name": "Pen", "price": 10 },
  { "name": "Pencil", "price": 10 },
  { "name": "Eraser", "price": 5 },
  { "name": "Sharpner", "price": 5 },
  { "name": "Scale", "price": 10 },
  { "name": "Geometry Box", "price": 100 },
  { "name": "Divider/Protector/Other", "Price": 50 },
  { "name": "Glitter pen", "price": 40 },
  { "name": "Marker","price": 40 },
  { "name": "Notebook", "price": 50 },
  { "name": "Long Notebook", "price": 70 },
  { "name": "Notebook big", "price": 120 },
  { "name": "Ruled book", "price": 40 },
  { "name": "Ruled book big", "price": 70 },
  { "name": "Dairy", "price": 130 },
  { "name": "A4/ legal/ others papers", "price": 390 },
  { "name": "Tags/ holders", "price": 70 },
  { "name": "Rubbers", "price": 40 },
  { "name": "Pads", "price": 140 },
  { "name": "Covers", "price": 130 },
  { "name": "stickers", "price": 40 },
  { "name": "Highlighter", "price": 50 },
  { "name": "stamps", "price": 10 },
  { "name": "bonds", "price": 100 },
  { "name": "support papers", "price": 40 },
  { "name": "Misc item", "price": 50 },
  { "name": "uni-ball Eye UB157 Roller Pen", "price": 790 },
  { "name": "Success Stationery Hero Fountain Pen (3-pack)", "price": 599 },
  { "name": "UNI-BALL PIN-200 Fineliner Set", "price": 558 },
  { "name": "FLAIR Glass Gel Pen Stand (50 pens)", "price": 500 },
  { "name": "KLIFFOO Dual Tip Art Markers (80 colors)", "price": 743 },
  { "name": "HAUSER XO Ball Pen Box (100 pens)", "price": 900 },
  { "name": "Pilot Hi-Tecpoint V5 Multicolor Set", "price": 845 },
  { "name": "Pierre Cardin President Fountain Pen", "price": 575 },
  { "name": "Neomate Dual-Tip Acrylic Markers (24 pcs)", "price": 548 },
  { "name": "Ohuhu Premium Metallic Marker Pens (10 pcs)", "price": 509 },
  { "name": "Camel Acrylic Markers (12 shades)", "price": 731 },
  { "name": "Ohuhu Fineliner Drawing Pen Set (8 pcs)", "price": 599 },
  { "name": "FLAIR Pastel Highlighter Set (5 pcs)", "price": 116 },
  { "name": "LUXOR Chisel Tip Highlighter Set", "price": 112 },
  { "name": "FABER-CASTELL Gel Textliner Set (8 pcs)", "price": 420 },
  { "name": "Staedtler Textsurfer Classic Highlighter (6 pcs)", "price": 615 },
  { "name": "Corslet 52pc Drawing Pencil Kit", "price": 885 },
  { "name": "Corslet 110pc Sketching Kit", "price": 1446 },
  { "name": "WISHKEY 150pc Art Set for Kids", "price": 399 },
  { "name": "Camel Art Studio Set", "price": 750 },
  { "name": "ABOUT SPACE Dual Tip Art Markers (60 colors)", "price": 598 },
  { "name": "Doms Art Strokes Kit", "price": 144 },
  { "name": "Corslet 73pc Sketching Kit", "price": 1260 },
  { "name": "Kitchen Bloom Unicorn Art Set (145 pcs)", "price": 999 },
  { "name": "Corslet 41pc Drawing Supplies Kit", "price": 628 },
  { "name": "BRuSTRO Artists Drawing Pad A4", "price": 292 },
  { "name": "ANUPAM Premium Artist Drawing Book", "price": 231 },
  { "name": "Askprints A5 Sketchbook (50 sheets)", "price": 130 },
  { "name": "Zaslan Drawing Book Sketch Pad", "price": 222 },
  { "name": "Classmate Pulse Spiral Notebook (Pack of 3)", "price": 257 },
  { "name": "NAVNEET HQ Single Subject Book", "price": 108 },
  { "name": "Factor Notes B6 Ruled Journal", "price": 99 },
  { "name": "AccuPrints Hard Bound Diary", "price": 181 },
  { "name": "Jiada Unicorn Spiral Diary", "price": 139 },
  { "name": "CAVALO Handmade Leather Diary", "price": 474 },
  { "name": "GLUN Fluorescent Sticky Notes", "price": 97 },
  { "name": "Pinzo Sticky Note Memo Pad", "price": 267 },
  { "name": "SHUTTLE ART Transparent Sticky Notes", "price": 138 },
  { "name": "Maped School Stationery Kit (20 pcs)", "price": 199 },
  { "name": "Doms Smart Kit (12 items)", "price": 477 },
  { "name": "Toy Imagine Unicorn Stationery Set", "price": 198 },
  { "name": "Cable World Space Stationery Kit", "price": 199 },
  { "name": "ROMYCRON Unicorn Stationery Kit", "price": 184 },
  { "name": "Barbarik Metal Pencil Box Set", "price": 246 },
  { "name": "Classmate Archimedes Geometry Box", "price": 171 },
  { "name": "Doms X1 Geometry Instrument Box", "price": 135 },
  { "name": "Camlin Scholar Geometry Set", "price": 111 },
  { "name": "Flair Hauser XO Writing Kit", "price": 100 },
  { "name": "Apsara 250 Writing Kit", "price": 250 },
  { "name": "Flair Student Club Creative Kit", "price": 275 },
  { "name": "Pentonic Smart Kit (5-in-1)", "price": 349 },
  { "name": "Doms Champions Kit", "price": 99 },
  { "name": "VGRASSP 7pc Stationery Set", "price": 189 },
  { "name": "Apsara Joy Kit", "price": 50 },
  { "name": "Le Delite Unicorn Combo Gift Pack", "price": 474 },
  { "name": "Classmate Longbook A4 Notebook", "price": 504 },
  { "name": "Classmate Pulse A4 Notebook", "price": 160 },
  { "name": "NAVNEET Youva Soft Bound Long Book", "price": 241 },
  { "name": "Paperkraft Green Impression A5 Notebook", "price": 174 },
  { "name": "Scholar Artist Sketch Shield Pad", "price": 247 },
  { "name": "True-Ally Index Flash Cards (200 pcs)", "price": 210 },
  { "name": "Climberty Desk Accessories Set", "price": 927 },
  { "name": "Kangaro Desk Essentials DE-Mini Combo", "price": 376 },
  { "name": "Cello Desk Station (23 items)", "price": 393 },
  { "name": "Snapdeal Eclet Certificate File", "price": 175 },
  { "name": "Snapdeal Fancy Rocket Notebook", "price": 360 },
  { "name": "Snapdeal Flipclips Unicorn Stationery Bag", "price": 497 },


  { "name": "Parker IM Fountain Pen", "price": 1850 },
  { "name": "Pilot V7 Hi-Tecpoint Pen", "price": 90 },
  { "name": "Lamy Safari Ballpoint Pen", "price": 1200 },
  { "name": "Pentel EnerGel-X Gel Pen", "price": 75 },
  { "name": "Reynolds Trimax Gel Pen", "price": 50 },
  { "name": "Faber-Castell Grip Pencil", "price": 35 },
  { "name": "Staedtler Noris HB Pencil", "price": 20 },
  { "name": "Camlin Kokuyo Mechanical Pencil", "price": 60 },
  { "name": "Tombow Mono Graph Pencil", "price": 250 },
  { "name": "Derwent Graphic Pencil Set", "price": 850 },
  { "name": "Sharpie Fine Point Marker", "price": 110 },
  { "name": "Luxor Permanent Marker", "price": 30 },
  { "name": "Copic Sketch Marker", "price": 350 },
  { "name": "Ohuhu Dual Tip Marker Set", "price": 999 },
  { "name": "Stabilo Boss Highlighter", "price": 45 },
  { "name": "Faber-Castell Textliner", "price": 60 },
  { "name": "Zebra Mildliner", "price": 120 },
  { "name": "Pilot FriXion Highlighter", "price": 95 },
  { "name": "Classmate Pulse Notebook", "price": 85 },
  { "name": "Navneet Youva Longbook", "price": 65 },
  { "name": "Factor Notes Journal", "price": 199 },
  { "name": "Leuchtturm1917 Hardcover Notebook", "price": 1450 },
  { "name": "Moleskine Classic Notebook", "price": 1750 },
  { "name": "Paperkraft Spiral Notepad", "price": 120 },
  { "name": "AmazonBasics Sticky Notes", "price": 99 },
  { "name": "Post-it Super Sticky Notes", "price": 150 },
  { "name": "Jiada Unicorn Diary", "price": 165 },
  { "name": "AccuPrints PU Leather Diary", "price": 181 },
  { "name": "Cavalo Handmade Travel Diary", "price": 474 },
  { "name": "Zen Sangam Watercolor Sketchbook", "price": 253 },
  { "name": "Brustro Artists Drawing Pad", "price": 292 },
  { "name": "Corslet 52pc Drawing Kit", "price": 885 },
  { "name": "Camel Artist Acrylic Paints", "price": 650 },
  { "name": "Doms Color Pencils 24 Shades", "price": 120 },
  { "name": "Staedtler Luna Watercolor Pencils", "price": 399 },
  { "name": "Winsor & Newton Brush Set", "price": 950 },
  { "name": "Faber-Castell Paint Brushes", "price": 275 },
  { "name": "Camel Craft Paper Pack", "price": 180 },
  { "name": "Maped Geometry Box Kit", "price": 199 },
  { "name": "Doms X1 Geometry Set", "price": 135 },
  { "name": "Nataraj Toolkit Geometry Set", "price": 170 },
  { "name": "Barbarik Metal Pencil Box", "price": 184 },
  { "name": "Toy Imagine Unicorn Stationery Set", "price": 198 },
  { "name": "Apsara Writing Kit", "price": 250 },
  { "name": "Flair Hauser XO Stationery Kit", "price": 100 },
  { "name": "Cable World Space Stationery Kit", "price": 199 },
  { "name": "ROMYCRON Unicorn Kit", "price": 184 },
  { "name": "Classmate Archimedes Geometry Box", "price": 171 },
  { "name": "Pentonic Smart Kit", "price": 349 },
  { "name": "Doms Champions Kit", "price": 99 },
  { "name": "Apsara Joy Kit", "price": 50 },
  { "name": "Flair Student Club Smart Kit", "price": 275 },
  { "name": "Cello Desk Station Set", "price": 393 },
  { "name": "Kangaro DE-Mini Combo Pack", "price": 297 },
  { "name": "Snapdeal Unicorn Diary Set", "price": 497 },
  { "name": "Classmate Invento Geometry Box", "price": 130 },
  { "name": "Solo Expanding File Folder", "price": 210 },
  { "name": "AmazonBasics Accordion Folder", "price": 399 },
  { "name": "Kokuyo Camlin Spiral Planner", "price": 275 },
  { "name": "Factor Notes Undated Planner", "price": 299 },
  { "name": "Moleskine Weekly Planner", "price": 1650 },
  { "name": "Navneet Desk Calendar 2025", "price": 129 },
  { "name": "INNAXA Mini Monthly Calendar", "price": 229 },
  { "name": "Askprints Wall Calendar", "price": 220 },
  { "name": "Magnetic Whiteboard 2x3 ft", "price": 999 },
  { "name": "Cello Whiteboard with Marker Set", "price": 850 },
  { "name": "AmazonBasics Dry Erase Board", "price": 1199 },
  { "name": "Luxor Whiteboard Marker Set", "price": 218 },
  { "name": "Zuvilika Acrylic Pens Set", "price": 297 },
  { "name": "Corslet 110pc Sketching Kit", "price": 1446 },
  { "name": "Camel Art Studio Set", "price": 750 },
  { "name": "WISHKEY 150pc Art Set", "price": 399 },

  { "name": "Parker IM Fountain Pen", "price": 1850 },
  { "name": "Pilot V7 Hi-Tecpoint Pen", "price": 90 },
  { "name": "Pentonic Gel Pen Pack of 10", "price": 120 },
  { "name": "Sheaffer Glossy Ballpoint Pen", "price": 855 },
  { "name": "VEA Solar Rollerball Pen", "price": 749 },
  { "name": "Camlin Supreme Pencil Pack", "price": 60 },
  { "name": "Faber-Castell Grip Pencil", "price": 25 },
  { "name": "Staedtler Noris HB Pencil", "price": 20 },
  { "name": "Luxor Chisel Tip Highlighter Set", "price": 112 },
  { "name": "Flair Pastel Highlighter Pack", "price": 125 },
  { "name": "Uni-Ball Eye Roller Pen", "price": 79 },
  { "name": "Brustro Fineliner Drawing Pen Set", "price": 599 },
  { "name": "Classmate Spiral Notebook A4", "price": 160 },
  { "name": "Navneet Youva Long Book", "price": 55 },
  { "name": "Factor Notes B6 Journal", "price": 99 },
  { "name": "Alcraft Handmade Diary", "price": 298 },
  { "name": "Portronics Ruffpad 15 LCD Pad", "price": 969 },
  { "name": "Sticky Notes Neon Pack", "price": 133 },
  { "name": "Pinzo Memo Pad with Index Tabs", "price": 267 },
  { "name": "Jiada Unicorn Spiral Diary", "price": 139 },
  { "name": "AccuPrints PU Leather Diary", "price": 181 },
  { "name": "Camel Brush Pen Set of 24", "price": 440 },
  { "name": "Corslet 52pc Drawing Kit", "price": 885 },
  { "name": "Doms Art Strokes Kit", "price": 144 },
  { "name": "Kitchen Bloom 145pc Art Set", "price": 999 },
  { "name": "Corslet 110pc Sketching Kit", "price": 1446 },
  { "name": "Camel Acrylic Paints 12 Shades", "price": 731 },
  { "name": "Ohuhu Metallic Marker Pens", "price": 509 },
  { "name": "Corslet A5 Sketchbook", "price": 189 },
  { "name": "Brustro Artist Drawing Pad", "price": 292 },
  { "name": "Anupam Ultra Artist Book A4", "price": 199 },
  { "name": "Askprints A5 Craft Cover Sketchpad", "price": 130 },
  { "name": "Zaslan Drawing Book", "price": 222 },
  { "name": "Maped Geometry Box Kit", "price": 199 },
  { "name": "Doms X1 Geometry Box", "price": 135 },
  { "name": "Classmate Archimedes Geometry Box", "price": 171 },
  { "name": "Barbarik Metal Pencil Box Set", "price": 184 },
  { "name": "ROMYCRON Unicorn Stationery Kit", "price": 184 },
  { "name": "Toy Imagine Space Theme Kit", "price": 199 },
  { "name": "Cable World Stationery Set", "price": 199 },
  { "name": "Apsara Writing Kit", "price": 250 },
  { "name": "Flair Hauser XO Writing Kit", "price": 100 },
  { "name": "Pentonic Smart Kit", "price": 349 },
  { "name": "Doms Champions Kit", "price": 99 },
  { "name": "Jiada Birthday Stationery Box", "price": 360 },
  { "name": "Snapdeal Unicorn Stationery Set", "price": 246 },
  { "name": "YESKART Construction Theme Kit", "price": 359 },
  { "name": "Le Delite Unicorn Diary Set", "price": 474 },
  { "name": "Camel Art Studio Set", "price": 750 },
  { "name": "Classmate Invento Geometry Box", "price": 130 },
  { "name": "Nataraj On Point Geometry Set", "price": 120 },
  { "name": "Flair Creative Sip Zip Kit", "price": 274 },
  { "name": "Snapdeal Princess Theme Kit", "price": 246 },
  { "name": "Snapdeal Sea Animal Theme Kit", "price": 246 },
  { "name": "Snapdeal Minions Theme Kit", "price": 176 },
  { "name": "Snapdeal Doraemon Theme Kit", "price": 469 },
  { "name": "Snapdeal Unicorn Diary Combo", "price": 209 },
  { "name": "Snapdeal Mini Stationery Combo", "price": 210 },
  { "name": "Snapdeal Flipclips Unicorn Bag Set", "price": 497 },
  { "name": "Snapdeal Kalra Diwali Hamper", "price": 360 },
  { "name": "Snapdeal Magic Practice Copybook", "price": 150 },
  { "name": "Snapdeal LED Tracing Board A4", "price": 1707 },
  { "name": "Snapdeal Scratch Magic Book", "price": 141 },
  { "name": "Snapdeal Beeslanz Water Book", "price": 184 },
  { "name": "Snapdeal RAMDEV Spinning Pen", "price": 313 },
  { "name": "Snapdeal True-Ally Index Cards", "price": 210 },
  { "name": "Snapdeal Scholar Sketch Shield", "price": 247 },
  { "name": "Snapdeal Zen Sangam Gouache Book", "price": 217 },
  { "name": "Snapdeal Zen Sangam Bookmark Pad", "price": 132 },
  { "name": "Snapdeal Zen Sangam Watercolor Book", "price": 253 },
  { "name": "Snapdeal LRS Sketch Book A5", "price": 198 },
  { "name": "Snapdeal NAVNEET Drawing Book", "price": 136 },
  { "name": "Snapdeal Classmate Pulse A4", "price": 160 },
  { "name": "Snapdeal Classmate Longbook", "price": 504 },

  { "name": "Parker IM Premium Fountain Pen", "price": 1850 },
  { "name": "Pilot V7 Hi-Tecpoint Roller Pen", "price": 90 },
  { "name": "Lamy Safari Ballpoint Pen", "price": 1350 },
  { "name": "Pentel EnerGel-X Gel Pen", "price": 60 },
  { "name": "Cross Century II Ballpoint Pen", "price": 3200 },
  { "name": "Faber-Castell Grip 2001 Pencil", "price": 25 },
  { "name": "Staedtler Noris HB Pencil", "price": 15 },
  { "name": "Tombow Mono Drawing Pencil", "price": 40 },
  { "name": "Derwent Graphic Pencil Set", "price": 650 },
  { "name": "Caran d'Ache Swiss Wood Pencil", "price": 120 },
  { "name": "Sharpie Fine Point Marker", "price": 75 },
  { "name": "Copic Sketch Marker", "price": 350 },
  { "name": "Winsor & Newton Promarker", "price": 275 },
  { "name": "Ohuhu Dual Tip Marker Set", "price": 999 },
  { "name": "Luxor Permanent Marker", "price": 30 },
  { "name": "Stabilo Boss Original Highlighter", "price": 50 },
  { "name": "Faber-Castell Textliner 48", "price": 45 },
  { "name": "Zebra Mildliner Double-Ended", "price": 65 },
  { "name": "Maped Highlighter Fluo Peps", "price": 40 },
  { "name": "Pilot FriXion Light Erasable Highlighter", "price": 85 },
  { "name": "Classmate Pulse Notebook A4", "price": 85 },
  { "name": "Navneet Youva Long Book", "price": 45 },
  { "name": "Factor Notes Spiral Journal", "price": 199 },
  { "name": "Paperkraft Green Impression Diary", "price": 275 },
  { "name": "Moleskine Classic Notebook", "price": 1450 },
  { "name": "Post-it Super Sticky Notes", "price": 120 },
  { "name": "3M Pop-up Sticky Note Dispenser", "price": 350 },
  { "name": "Pinzo Neon Sticky Notes", "price": 75 },
  { "name": "Shuttle Art Transparent Sticky Notes", "price": 135 },
  { "name": "UCRAVO Clear Sticky Tabs", "price": 118 },
  { "name": "Kangaro HD-10D Stapler", "price": 135 },
  { "name": "Maped Essentials Stapler Set", "price": 199 },
  { "name": "Cello Desk Station Combo", "price": 393 },
  { "name": "Climberty Desk Organizer Kit", "price": 927 },
  { "name": "Deli E0563 Tape Dispenser", "price": 210 },
  { "name": "Scotch Magic Tape Dispenser", "price": 325 },
  { "name": "Fiskars Titanium Scissors", "price": 275 },
  { "name": "Kangaro Paper Punch DP-280", "price": 240 },
  { "name": "Brustro Artist Sketchbook A4", "price": 292 },
  { "name": "Anupam Ultra Artist Book A3", "price": 394 },
  { "name": "Corslet 110 Pc Sketching Kit", "price": 1446 },
  { "name": "Camel Artist Water Colours 24 Shades", "price": 750 },
  { "name": "Doms Art Strokes Kit", "price": 144 },
  { "name": "Winsor & Newton Acrylic Paint Set", "price": 1850 },
  { "name": "Princeton Velvetouch Paint Brushes", "price": 950 },
  { "name": "Camel Premium Brush Set", "price": 399 },
  { "name": "Craftvilla Handmade Craft Paper Pack", "price": 199 },
  { "name": "ROMYCRON Unicorn Stationery Kit", "price": 184 },
  { "name": "Maped Geometry Box 9pc", "price": 199 },
  { "name": "Doms X1 Geometry Set", "price": 135 },
  { "name": "Classmate Invento Geometry Box", "price": 171 },
  { "name": "Barbarik Metal Pencil Box", "price": 199 },
  { "name": "Apsara Writing Kit", "price": 250 },
  { "name": "Flair Hauser XO Stationery Kit", "price": 100 },
  { "name": "Toy Imagine Space Stationery Set", "price": 199 },
  { "name": "Snapdeal YESKART 12pc Stationery Combo", "price": 246 },
  { "name": "Classmate Archimedes Geometry Box", "price": 130 },
  { "name": "Solo Ring Binder File", "price": 145 },
  { "name": "Oddy Executive Folder", "price": 199 },
  { "name": "Kokuyo Camlin Document Holder", "price": 275 },
  { "name": "AmazonBasics Expanding File Folder", "price": 399 },
  { "name": "Navneet Youva Planner 2025", "price": 185 },
  { "name": "Moleskine Weekly Planner", "price": 1650 },
  { "name": "Factor Notes Undated Planner", "price": 299 },
  { "name": "Askprints Desk Calendar 2025", "price": 229 },
  { "name": "INNAXA Mini Monthly Calendar", "price": 229 },
  { "name": "Magiboards Magnetic Whiteboard A3", "price": 850 },
  { "name": "Cello Whiteboard with Marker Set", "price": 499 },
  { "name": "Reynolds Whiteboard Marker Set", "price": 238 },
  { "name": "Luxor Fluorescent Whiteboard Marker", "price": 218 },
  { "name": "Title Refillable Whiteboard Marker Set", "price": 284 },

  { "name": "Qurtasia 43-in-1 Office Stationery Combo", "price": 682 },
  { "name": "Snapdeal Eclet Certificate File", "price": 175 },
  { "name": "SEJASCOLLECTIONS Multicolor Chart Sheets Pack of 10", "price": 399 },
  { "name": "CUBIC White Chart Paper Pack of 10", "price": 250 },
  { "name": "Eclet A4 100 Coloured Sheets", "price": 151 },
  { "name": "OFIXO 100 Pieces Colour Sheets A4", "price": 142 },
  { "name": "SEJASCOLLECTIONS White Chart Paper Pack of 10", "price": 370 },
  { "name": "Eclet A4 Black Paper Pack of 20", "price": 89 },
  { "name": "SEJASCOLLECTIONS Pastel Chart Sheets Pack of 20", "price": 499 },
  { "name": "VCP Educational Chart Set for Kids (12 Charts)", "price": 228 },
  { "name": "Eclet Ivory Drawing Paper Combo Pack of 20", "price": 165 },
  { "name": "DSR Glitter Sheets A4 Pack of 10", "price": 179 },
  { "name": "SNOW CRAFTS A4 Premium Coloured Sheets Pack of 100", "price": 151 },
  { "name": "BRUSTRO Copytinta Mixed Bright Colour Craft Paper", "price": 120 },
  { "name": "SEJASCOLLECTIONS Black Chart Paper Pack of 12", "price": 425 },
  { "name": "SEJASCOLLECTIONS Yellow Chart Paper Pack of 10", "price": 399 },
  { "name": "FIRST CLICK White Chart Paper Pack of 5", "price": 199 },
  { "name": "FIRST CLICK Black Chart Paper Pack of 5", "price": 199 },
  { "name": "Multicolor Chart Paper A1 Pack of 10", "price": 389 },
  { "name": "Eclet 40 pcs Color A4 Medium Sheets", "price": 99 },
  { "name": "SEJASCOLLECTIONS Light Blue Chart Paper Pack of 10", "price": 370 },
  { "name": "Eclet LCD Writing Pad 8.5", "price": 165 },
  { "name": "Snapdeal Fancy Rocket Notebook", "price": 360 },
  { "name": "Snapdeal Kalra Diwali Stationery Hamper", "price": 360 },
  { "name": "Snapdeal Magic Practice Copybook", "price": 150 },
  { "name": "Snapdeal LED Tracing Board A4", "price": 1707 },
  { "name": "Snapdeal Scratch Magic Book", "price": 141 },
  { "name": "Snapdeal Beeslanz Water Book", "price": 184 },
  { "name": "Snapdeal RAMDEV Spinning Pen", "price": 313 },
  { "name": "Snapdeal Zen Sangam Gouache Book", "price": 217 },
  { "name": "Snapdeal Zen Sangam Bookmark Pad", "price": 132 },
  { "name": "Snapdeal Zen Sangam Watercolor Book", "price": 253 },
  { "name": "Snapdeal LRS Sketch Book A5", "price": 198 },
  { "name": "Snapdeal NAVNEET Drawing Book", "price": 136 },
  { "name": "Snapdeal Classmate Pulse A4", "price": 160 },
  { "name": "Snapdeal Classmate Longbook", "price": 504 },
  { "name": "Snapdeal Flipclips Unicorn Stationery Bag", "price": 497 },
  { "name": "Snapdeal Mini Stationery Combo", "price": 210 },
  { "name": "Snapdeal Unicorn Diary Combo", "price": 209 },
  { "name": "Snapdeal Doraemon Theme Kit", "price": 469 },
  { "name": "Snapdeal Minions Theme Kit", "price": 176 },
  { "name": "Snapdeal Sea Animal Theme Kit", "price": 246 },
  { "name": "Snapdeal Princess Theme Kit", "price": 246 },
  { "name": "Snapdeal YESKART Construction Theme Kit", "price": 359 },
  { "name": "Snapdeal Jiada Birthday Stationery Box", "price": 360 },
  { "name": "Snapdeal Eclet Brown Certificate File", "price": 299 },
  { "name": "Snapdeal Eclet Black Certificate File", "price": 175 },
  { "name": "Snapdeal Eclet A4 100 Coloured Sheets", "price": 159 },
  { "name": "Snapdeal Eclet A4 Black Paper Pack of 20", "price": 89 },
  { "name": "Snapdeal Eclet A4 Ivory Drawing Sheets Pack of 20", "price": 165 },
  { "name": "Snapdeal Eclet Multicolor Chart Sheets Pack of 10", "price": 399 },
  { "name": "Snapdeal Eclet White Chart Paper Pack of 10", "price": 370 },
  { "name": "Snapdeal Eclet Pastel Chart Sheets Pack of 20", "price": 499 },
  { "name": "Snapdeal Eclet Decorative Tape Pack", "price": 205 },
  { "name": "Snapdeal Eclet Pop-up Map", "price": 158 },
  { "name": "Snapdeal Eclet Transparent Gel Tape", "price": 218 },
  { "name": "Snapdeal Eclet Fancy Shark Notebook", "price": 360 },
  { "name": "Snapdeal Eclet See You In Dreamland Notebook", "price": 349 },
  { "name": "Snapdeal Eclet Case Bound Long Book Pack of 5", "price": 749 },
  { "name": "Snapdeal Eclet Button Bag Pack of 5", "price": 270 },
  { "name": "Snapdeal Eclet Lanyards Pack of 10", "price": 407 },
  { "name": "Snapdeal Eclet ID Card Holder", "price": 532 },
  { "name": "Snapdeal Eclet Visiting Card Holder", "price": 236 },
  { "name": "Snapdeal Eclet Laser Pointer Pen", "price": 799 },
  { "name": "Snapdeal Eclet Fancy Rocket Notebook", "price": 360 },
  { "name": "Snapdeal Eclet LCD Writing Pad", "price": 165 },
  { "name": "Snapdeal Eclet Combo Wallet Set", "price": 385 },
  { "name": "Snapdeal Eclet Combo Gift Pack", "price": 474 },
  { "name": "Snapdeal Eclet Combo of 2 Stylish Wallets", "price": 361 },
  { "name": "Snapdeal Eclet Combo of 2 Card Holders", "price": 411 },
  { "name": "Snapdeal Eclet Combo of 2 Wallets", "price": 385 },


                  ],
        "Gifts": [

      { "name": "Giftana Personalized Diary & Pen Set", "price": 807 },
  { "name": "CrownLit Custom Name Pen & Keychain Combo", "price": 649 },
  { "name": "Tempt Engraved Pen with Golden Flakes", "price": 212 },
  { "name": "Present Mart Personalized Office Diary", "price": 399 },
  { "name": "Jhingalala Custom Photo Diary", "price": 249 },
  { "name": "AICA Personalized Leather Notebook", "price": 399 },
  { "name": "Brown Cloud Velvet Personalized Diary", "price": 575 },
  { "name": "Gift Kya De Personalized Desk Organizer", "price": 599 },
  { "name": "Cross Art Engraved Pen & Keychain Set", "price": 399 },
  { "name": "Innovative Gifts Gold Flake Roller Pen", "price": 258 },
  { "name": "Zooboo Personalized Kids Spiral Notebook", "price": 240 },
  { "name": "Teak Wood Personalized Pen Stand", "price": 499 },
  { "name": "Express Laser Engraved Pencil Box Set", "price": 185 },
  { "name": "MADE 4R U Custom Name Pencils (10 pcs)", "price": 299 },
  { "name": "Toy Imagine Unicorn Stationery Set", "price": 198 },
  { "name": "Giftorious Personalized Wallet & Pen Combo", "price": 599 },
  { "name": "Tempt 3-in-1 Personalized Organizer Set", "price": 595 },
  { "name": "SAVRI Doctor’s Personalized Desk Set", "price": 1234 },
  { "name": "AICA Magnetic Stick Leather Diary Set", "price": 499 },
  { "name": "SAVRI Engraved Dark Pencil Set (20 pcs)", "price": 378 },
  { "name": "Toy Imagine Space Theme Stationery Kit", "price": 229 },
  { "name": "Parteet Cartoon Printed Pouch Set (12 pcs)", "price": 699 },
  { "name": "JIADA Fancy Stationery Return Gift Box", "price": 434 },
  { "name": "VGRASSP 7pc Stationery Toy Set", "price": 189 },
  { "name": "PARTEET Mix Stationery Kit (12 pcs)", "price": 399 },
  { "name": "Party Propz Dinosaur Theme Stationery Set", "price": 218 },
  { "name": "Toyshine Cartoon Theme Combo Kit (5 pcs)", "price": 399 },
  { "name": "JIADA Space Astronaut Stationery Set", "price": 109 },
  { "name": "MONKEYTAIL Jungle Safari Combo Pack (70 pcs)", "price": 1324 },
  { "name": "SILLYME Soft Silicon Pencil Pouch Set (10 pcs)", "price": 999 },
  { "name": "Tera 13 Cartoon Stationery Gift Pack", "price": 279 },
  { "name": "Goodgudi DIY Scratch Art Notebook Kit", "price": 249 },
  { "name": "AutoStory Junk Journal Scrapbook Kit", "price": 749 },
  { "name": "VIBE VISTA Vintage Scrapbook Kit", "price": 349 },
  { "name": "JOYCHOIC Creative Journaling Kit", "price": 1499 },
  { "name": "Draupnir Bullet Journal Scrapbook Kit", "price": 1299 },
  { "name": "NISHIV Aesthetic Junk Journal Kit", "price": 389 },
  { "name": "CRAFT WORLD Starry Night Scrapbook Kit", "price": 499 },
  { "name": "ATIRAMANIYA Poetry Scrapbook Kit", "price": 799 },
  { "name": "Mluffy Collage Album Sticker Kit", "price": 299 },
  { "name": "Funto Rose Whisper Scrapbooking Kit", "price": 1499 },
  { "name": "Knaid Celestial Scrapbook Supplies Pack", "price": 899 },
  { "name": "CHRYCELESTE Nostalgic Memory Journal Kit", "price": 799 },
  { "name": "Vintage Botanical Scrapbook Kit", "price": 1199 },
  { "name": "JOYCHOIC Journaling Kit for Beginners", "price": 1299 },
  { "name": "ZICOTO All-in-One Journaling Kit", "price": 699 },
  { "name": "emmoolife Floral Scrapbook Gift Set", "price": 999 },
  { "name": "FAYWARE Famous Paintings Sticker Pack", "price": 1399 },
  { "name": "Esweny Artistic Scrapbook Kit", "price": 999 },
  { "name": "PANZIYU Oil Painting Journal Kit", "price": 1699 },
  { "name": "LCLAIDYDY 348pc Vintage Journal Kit", "price": 1199 },
  { "name": "ZEBRA Journaling Gift Set (33 pcs)", "price": 2499 },
  { "name": "PAPERAGE Bullet Journal Stationery Kit", "price": 2199 },
  { "name": "YagCu Aesthetic Scrapbook Bundle", "price": 999 },
  { "name": "Penz Montblanc Meisterstück Fountain Pen", "price": 18500 },
  { "name": "Penz Lamy 2000 Fountain Pen", "price": 5999 },
  { "name": "Penz Parker Sonnet Ballpoint Pen", "price": 3499 },
  { "name": "Penz Cross Townsend Rollerball Pen", "price": 4999 },
  { "name": "Penz Pelikan Souverän M800 Fountain Pen", "price": 16500 },
  { "name": "Penz Graf von Faber-Castell Classic Pen", "price": 14500 },
  { "name": "Scriveiner Chrome Fountain Pen", "price": 5499 },
  { "name": "Scriveiner Black Lacquer Rollerball Pen", "price": 3999 },
  { "name": "Aurora Diamante Fountain Pen", "price": 1500000 },
  { "name": "Caran d'Ache 1010 Diamonds Pen", "price": 1000000 },
  { "name": "Visconti Alchemy H.R.H. Pen", "price": 57000 },
  { "name": "Nakaya Piccolo Writer Pen", "price": 7000 },
  { "name": "Platinum Solitaire Black Diamond Pen", "price": 48000 },
  { "name": "S.T. Dupont Haute Creation Prestige Pen", "price": 40000 },
  { "name": "Montblanc Heritage Collection Pen", "price": 1000000 },
  { "name": "Limited Edition Omaso Phoenix Platinum Pen", "price": 60000 },
  { "name": "Wytbook Kraft Notebook by PrintSpeaks", "price": 3979 },
  { "name": "Prestige Leather Notebook Set", "price": 889 },
  { "name": "ClassyLeather Notebook Essentials Kit", "price": 709 },

  { "name": "PrintStop Custom Logo Notebook", "price": 439 },
  { "name": "Nutcase Engraved Red Pen", "price": 499 },
  { "name": "Trophykart FTJ Sr 142 Brown Flap Diary", "price": 510 },
  { "name": "Brown Cloud Personalized Velvet Diary", "price": 575 },
  { "name": "CrownLit Custom Pen & Keychain Combo", "price": 649 },
  { "name": "Gift Kya De Personalized Desk Organizer", "price": 599 },
  { "name": "Tempt Engraved Pen with Golden Flakes", "price": 212 },
  { "name": "Present Mart Personalized Office Diary", "price": 399 },
  { "name": "Zooboo Personalized Kids Spiral Notebook", "price": 240 },
  { "name": "AICA Personalized Leather Notebook", "price": 399 },
  { "name": "MADE 4R U Custom Name Pencils", "price": 299 },
  { "name": "Teak Wood Personalized Pen Stand", "price": 499 },
  { "name": "Express Laser Engraved Pencil Box", "price": 185 },
  { "name": "Innovative Gifts Gold Flake Roller Pen", "price": 258 },
  { "name": "Toy Imagine Unicorn Diary Set", "price": 198 },
  { "name": "Tempt 3-in-1 Organizer Gift Set", "price": 595 },
  { "name": "SAVRI Doctor’s Personalized Desk Set", "price": 1234 },
  { "name": "AICA Magnetic Stick Diary Set", "price": 499 },
  { "name": "SAVRI Engraved Dark Pencil Set", "price": 378 },
  { "name": "Parteet Cartoon Pouch Set", "price": 699 },
  { "name": "JIADA Fancy Return Gift Box", "price": 434 },
  { "name": "VGRASSP 7pc Stationery Toy Set", "price": 189 },
  { "name": "PARTEET Mix Stationery Kit", "price": 399 },
  { "name": "Toyshine Cartoon Combo Kit", "price": 399 },
  { "name": "JIADA Space Astronaut Set", "price": 109 },
  { "name": "MONKEYTAIL Jungle Safari Pack", "price": 1324 },
  { "name": "SILLYME Silicon Pouch Set", "price": 999 },
  { "name": "Tera 13 Cartoon Gift Pack", "price": 279 },
  { "name": "Goodgudi Scratch Art Notebook", "price": 249 },
  { "name": "AutoStory Junk Journal Kit", "price": 749 },
  { "name": "VIBE VISTA Vintage Scrapbook Kit", "price": 349 },
  { "name": "JOYCHOIC Creative Journaling Kit", "price": 1499 },
  { "name": "Draupnir Bullet Journal Kit", "price": 1299 },
  { "name": "NISHIV Aesthetic Journal Kit", "price": 389 },
  { "name": "CRAFT WORLD Starry Night Scrapbook", "price": 499 },
  { "name": "ATIRAMANIYA Poetry Scrapbook Kit", "price": 799 },
  { "name": "Mluffy Collage Album Sticker Kit", "price": 299 },
  { "name": "Funto Rose Whisper Scrapbook Kit", "price": 1499 },
  { "name": "Knaid Celestial Scrapbook Supplies", "price": 899 },
  { "name": "CHRYCELESTE Nostalgic Memory Kit", "price": 799 },
  { "name": "Vintage Botanical Scrapbook Kit", "price": 1199 },
  { "name": "ZICOTO All-in-One Journaling Kit", "price": 699 },
  { "name": "emmoolife Floral Scrapbook Set", "price": 999 },
  { "name": "FAYWARE Famous Paintings Sticker Pack", "price": 1399 },
  { "name": "Esweny Artistic Scrapbook Kit", "price": 999 },
  { "name": "PANZIYU Oil Painting Journal Kit", "price": 1699 },
  { "name": "LCLAIDYDY 348pc Vintage Journal Kit", "price": 1199 },
  { "name": "ZEBRA Journaling Gift Set", "price": 2499 },
  { "name": "PAPERAGE Bullet Journal Stationery Kit", "price": 2199 },
  { "name": "YagCu Aesthetic Scrapbook Bundle", "price": 999 },
  { "name": "Montblanc Meisterstück Fountain Pen", "price": 18500 },
  { "name": "Lamy 2000 Fountain Pen", "price": 5999 },
  { "name": "Parker Sonnet Ballpoint Pen", "price": 3499 },
  { "name": "Cross Townsend Rollerball Pen", "price": 4999 },
  { "name": "Pelikan Souverän M800 Fountain Pen", "price": 16500 },
  { "name": "Graf von Faber-Castell Classic Pen", "price": 14500 },
  { "name": "Scriveiner Chrome Fountain Pen", "price": 5499 },
  { "name": "Scriveiner Black Lacquer Rollerball", "price": 3999 },
  { "name": "Aurora Diamante Fountain Pen", "price": 1500000 },
  { "name": "Caran d'Ache 1010 Diamonds Pen", "price": 1000000 },
  { "name": "Visconti Alchemy H.R.H. Pen", "price": 57000 },
  { "name": "Nakaya Piccolo Writer Pen", "price": 7000 },
  { "name": "Platinum Solitaire Black Diamond Pen", "price": 48000 },
  { "name": "S.T. Dupont Haute Creation Prestige Pen", "price": 40000 },
  { "name": "Montblanc Heritage Collection Pen", "price": 1000000 },
  { "name": "Limited Edition Omaso Phoenix Platinum Pen", "price": 60000 },
  { "name": "Wytbook Kraft Notebook by PrintSpeaks", "price": 3979 },
  { "name": "Prestige Leather Notebook Set", "price": 889 },
  { "name": "ClassyLeather Notebook Essentials Kit", "price": 709 },


  { "name": "Bigsmall Astronaut Moon Lamp", "price": 3499 },
  { "name": "CraftVatika Panda Miniature Set", "price": 299 },
  { "name": "NYRWANA Astronaut Planet Mug", "price": 548 },
  { "name": "Glowrite Acrylic LED Writing Board", "price": 795 },
  { "name": "One94Store Galaxy Crystal Ball Lamp", "price": 199 },
  { "name": "STRIFF Adjustable Laptop Stand", "price": 249 },
  { "name": "Flashing Click Mini Photo Album Keychain", "price": 474 },
  { "name": "One94Store Silicone Panda Night Light", "price": 370 },
  { "name": "XBEY Anti-Theft Sling Bag", "price": 699 },
  { "name": "Street27 Knitted Wrist Handbag", "price": 295 },
  { "name": "Beauté Secrets 18pc Manicure Kit", "price": 499 },
  { "name": "ALCRAFT Handmade Diary with Lock", "price": 298 },
  { "name": "CPENSUS Marble Finish Couple Mug Set", "price": 769 },
  { "name": "Sichumaria Happy Birthday Music Box", "price": 438 },
  { "name": "eCraftIndia Cute Couple Statue", "price": 278 },
  { "name": "PRINTHUA Personalized LED Table Lamp", "price": 379 },
  { "name": "AICA Customized Wallet Gift Hamper", "price": 999 },
  { "name": "The Unique Gift Studio Passport Cover", "price": 266 },
  { "name": "ZAHEPA Airplane Mini Desk Clock", "price": 659 },
  { "name": "PALAY Cross-Body Phone Bag", "price": 596 },
  { "name": "Desidiya Lying Panda Touch Lamp", "price": 394 },
  { "name": "TIED RIBBONS 24k Gold Rose", "price": 189 },
  { "name": "COI Sticky Notes Memo Book", "price": 199 },
  { "name": "FYA Steel Tongue Drum Kit", "price": 2798 },
  { "name": "Collectible India Laxmi Ganesh Diya", "price": 583 },
  { "name": "AICA Personalized USB LED Lamp", "price": 399 },
  { "name": "Festiko Romantic Love Notes Set", "price": 145 },
  { "name": "Kimirica Love Story Bath Gift Set", "price": 1185 },
  { "name": "GIFTOS365 Wooden Nose Eyeglass Holder", "price": 235 },
  { "name": "Bigsmall Volcano Humidifier", "price": 1999 },
  { "name": "Bigsmall Hot Air Balloon Flip Clock", "price": 2499 },
  { "name": "Bigsmall SandGlow Rotating Lamp", "price": 1799 },
  { "name": "Bigsmall Beating Heart Wall Clock", "price": 1499 },
  { "name": "Bigsmall Chalkboard Map DIY", "price": 1799 },
  { "name": "Bigsmall Foldable Cone Light", "price": 899 },
  { "name": "Bigsmall Elephant Incense Burner", "price": 799 },
  { "name": "Bigsmall Vintage Gramophone Speaker", "price": 1899 },
  { "name": "Bigsmall Wooden City Desk Tidy", "price": 1699 },
  { "name": "Bigsmall Spin Shade LED Glass", "price": 699 },
  { "name": "Bigsmall 4-in-1 Speaker & Charger", "price": 2499 },
  { "name": "Bigsmall Automatic Pan Stirrer", "price": 999 },
  { "name": "Bigsmall Vibe Stand Speaker", "price": 1150 },
  { "name": "Bigsmall Rave Shade LED Glass", "price": 699 },
  { "name": "Bigsmall Personalized Gadget Organizer", "price": 1299 },
  { "name": "Giftcart Sitting Buddha Statue", "price": 1299 },
  { "name": "Giftcart Engraved Wooden Keychain", "price": 399 },
  { "name": "Giftcart Personalised Belle Picture Stand", "price": 249 },
  { "name": "Giftcart Customized Mom Story Book", "price": 699 },
  { "name": "Giftcart Collector's Tea Box Kit", "price": 5900 },
  { "name": "Giftcart Ceramic Couple Mug Set", "price": 450 },
  { "name": "Giftcart Heart Couple Mug", "price": 499 },
  { "name": "Giftcart Personalized Heart Photo Frame", "price": 599 },
  { "name": "Giftcart Dexter Reusable Notebook", "price": 799 },
  { "name": "Giftcart Chees Bite Smiley Cushion", "price": 349 },
  { "name": "Giftcart Mini Football Stress Ball", "price": 699 },
  { "name": "Giftcart Bubble Bath Gag Gift", "price": 249 },
  { "name": "Giftcart Straw Hat Gag Gift", "price": 399 },
  { "name": "Giftcart Paperwork Gag Gift", "price": 299 },
  { "name": "Giftcart Hair Dryer Gag Gift", "price": 299 },
  { "name": "Giftcart X Box Gag Gift", "price": 299 },
  { "name": "Giftcart Personalized Lawyer Stand", "price": 249 },
  { "name": "Giftcart Personalized Rock Star Stand", "price": 249 },
  { "name": "Giftcart Personalized Chef Stand", "price": 249 },
  { "name": "Giftcart Personalized Baby Poster", "price": 699 },
  { "name": "Giftcart Personalized What I Love About You Book", "price": 699 },
  { "name": "Giftcart Personalized Lady Doctor Stand", "price": 249 },
  { "name": "Giftcart Personalized Superboy Stand", "price": 249 },
  { "name": "Giftcart Personalized Superman Stand", "price": 249 },
  { "name": "Giftcart Personalized Heart Revolving Frame", "price": 599 },
  { "name": "Giftcart Personalized Pen Sleeve", "price": 399 },
  { "name": "Giftcart Personalized Conversation Magnets", "price": 499 },


  { "name": "Bigsmall Magnetic Night Light Clock", "price": 1499 },
  { "name": "Bigsmall Heng Lamp with Wireless Charger", "price": 1999 },
  { "name": "Bigsmall Classic Mountain Table Lamp", "price": 1399 },
  { "name": "Bigsmall Axe Shaped Pizza Cutter", "price": 399 },
  { "name": "Bigsmall Table Tennis Rubberpad Notebooks (Set of 3)", "price": 499 },
  { "name": "Bigsmall Volcano Humidifier", "price": 1999 },
  { "name": "Bigsmall Hot Air Balloon Flip Clock", "price": 2499 },
  { "name": "Bigsmall SandGlow Rotating Lamp", "price": 1799 },
  { "name": "Bigsmall Beating Heart Wall Clock", "price": 1499 },
  { "name": "Bigsmall Chalkboard Map DIY", "price": 1799 },
  { "name": "Bigsmall Foldable Cone Light", "price": 899 },
  { "name": "Bigsmall Elephant Incense Burner", "price": 799 },
  { "name": "Bigsmall Vintage Gramophone Speaker", "price": 1899 },
  { "name": "Bigsmall Wooden City Desk Tidy", "price": 1699 },
  { "name": "Bigsmall Spin Shade LED Glass", "price": 699 },
  { "name": "Bigsmall 4-in-1 Speaker & Charger", "price": 2499 },
  { "name": "Bigsmall Automatic Pan Stirrer", "price": 999 },
  { "name": "Bigsmall Vibe Stand Speaker", "price": 1150 },
  { "name": "Bigsmall Rave Shade LED Glass", "price": 699 },
  { "name": "Bigsmall Personalized Gadget Organizer", "price": 1299 },
  { "name": "Giftcart Sitting Buddha Statue", "price": 1299 },
  { "name": "Giftcart Engraved Wooden Keychain", "price": 399 },
  { "name": "Giftcart Belle Picture Stand", "price": 249 },
  { "name": "Giftcart Customized Mom Story Book", "price": 699 },
  { "name": "Giftcart Lady Doctor Picture Stand", "price": 249 },
  { "name": "Giftcart Best Brother Beer Mug", "price": 699 },
  { "name": "Giftcart Collector's Tea Box Kit", "price": 5900 },
  { "name": "Giftcart Ceramic Couple Mug Set", "price": 450 },
  { "name": "Giftcart Heart Couple Mug", "price": 499 },
  { "name": "Giftcart Personalized Heart Frame", "price": 599 },
  { "name": "Giftcart Dexter Reusable Notebook", "price": 799 },
  { "name": "Giftcart Chees Bite Smiley Cushion", "price": 349 },
  { "name": "Giftcart Mini Football Stress Ball", "price": 699 },
  { "name": "Giftcart Bubble Bath Gag Gift", "price": 249 },
  { "name": "Giftcart Straw Hat Gag Gift", "price": 399 },
  { "name": "Giftcart Paperwork Gag Gift", "price": 299 },
  { "name": "Giftcart Hair Dryer Gag Gift", "price": 299 },
  { "name": "Giftcart X Box Gag Gift", "price": 299 },
  { "name": "Giftcart Personalized Lawyer Stand", "price": 249 },
  { "name": "Giftcart Personalized Rock Star Stand", "price": 249 },
  { "name": "Giftcart Personalized Chef Stand", "price": 249 },
  { "name": "Giftcart Personalized Baby Poster", "price": 699 },
  { "name": "Giftcart Personalized What I Love About You Book", "price": 699 },
  { "name": "Giftcart Personalized Lady Doctor Stand", "price": 249 },
  { "name": "Giftcart Personalized Superboy Stand", "price": 249 },
  { "name": "Giftcart Personalized Superman Stand", "price": 249 },
  { "name": "Giftcart Personalized Heart Revolving Frame", "price": 599 },
  { "name": "Giftcart Personalized Pen Sleeve", "price": 399 },
  { "name": "Giftcart Conversation Magnets Set", "price": 499 },
  { "name": "Giftcart Personalized Belle Stand", "price": 249 },
  { "name": "Giftcart Personalized Mom Poster", "price": 699 },
  { "name": "Giftcart Personalized Sister Book", "price": 699 },
  { "name": "Giftcart Personalized Dad Keychain", "price": 399 },
  { "name": "Giftcart Personalized Mark the Date Keychain", "price": 399 },
  { "name": "Giftcart Personalized Couple Mug Set", "price": 450 },
  { "name": "Giftcart Personalized Ceramic Mug", "price": 400 },
  { "name": "Giftcart Personalized What I Love About You Sister Book", "price": 699 },
  { "name": "Giftcart Personalized Baby Boy Poster", "price": 699 },
  { "name": "Giftcart Personalized Lawyer Picture Stand", "price": 249 },
  { "name": "Giftcart Personalized Superboy Picture Stand", "price": 249 },
  { "name": "Giftcart Personalized Superman Picture Stand", "price": 249 },
  { "name": "Giftcart Personalized Rock Star Picture Stand", "price": 249 },
  { "name": "Giftcart Personalized Chef Picture Stand", "price": 249 },
  { "name": "Giftcart Personalized Lady Doctor Picture Stand", "price": 249 },
  { "name": "Giftcart Personalized Belle Picture Stand", "price": 249 },
  { "name": "Giftcart Personalized Baby Poster", "price": 699 },
  { "name": "Giftcart Personalized What I Love About You Book", "price": 699 },
  { "name": "Giftcart Personalized Heart Frame Keychain", "price": 399 },
  { "name": "Giftcart Personalized Wooden Keychain", "price": 399 },
  { "name": "Giftcart Personalized Couple Mug", "price": 499 },
  { "name": "Giftcart Personalized Ceramic Mug Set", "price": 450 },
  { "name": "Giftcart Personalized Heart Mug", "price": 499 },
  { "name": "Glass item Giftbox", "price": 2499 },
  { "name": "Antique piece item Giftbox", "price": 4499 },
  { "name": "Wood-related item Giftbox", "price": 2499 },
  { "name": "Photo item Giftbox", "price": 1499 },
  { "name": "Card item Giftbox", "price": 499 },
  { "name": "Creative item Giftbox", "price": 899 },
  { "name": "Custom item Giftbox", "price": 1499 },
  { "name": "Gift Box", "price": 9499 },


                  ],
        "Plastic items": [

      { "name": "Cello Plastic Storage Container Set (18 pcs)", "price": 849 },
  { "name": "Milton Smart Tiffin Box", "price": 299 },
  { "name": "Nayasa Plastic Water Jug 3L", "price": 199 },
  { "name": "Signoraware Modular Fridge Bottle Set", "price": 399 },
  { "name": "Tupperware Classic Lunch Set", "price": 999 },
  { "name": "Cello Plastic Dustbin with Lid", "price": 325 },
  { "name": "Pigeon Plastic Bucket 20L", "price": 249 },
  { "name": "Kuber Industries Plastic Laundry Basket", "price": 499 },
  { "name": "AmazonBasics Plastic Drawer Organizer", "price": 699 },
  { "name": "Nilkamal Plastic Stool", "price": 399 },
  { "name": "Cello Plastic Chair (Set of 2)", "price": 1499 },
  { "name": "Supreme Plastic Table", "price": 999 },
  { "name": "Kuber Industries Plastic Hanger Set (12 pcs)", "price": 199 },
  { "name": "Cello Plastic Mop Bucket with Wheels", "price": 799 },
  { "name": "Scotch-Brite Plastic Dustpan", "price": 149 },
  { "name": "Milton Plastic Bathroom Set (5 pcs)", "price": 599 },
  { "name": "Pigeon Plastic Planter Pot (Pack of 3)", "price": 399 },
  { "name": "Kuber Industries Plastic Drawer Rack", "price": 1299 },
  { "name": "Nilkamal Plastic Shoe Rack", "price": 1799 },
  { "name": "Cello Plastic Kitchen Rack", "price": 899 },
  { "name": "Milton Plastic Ice Tray Set", "price": 199 },
  { "name": "Tupperware Plastic Food Tray", "price": 349 },
  { "name": "AmazonBasics Plastic Cutlery Set (24 pcs)", "price": 499 },
  { "name": "Signoraware Plastic Mixing Bowl Set", "price": 599 },
  { "name": "Kuber Industries Plastic Mug Set", "price": 299 },
  { "name": "Cello Plastic Water Bottle 1L", "price": 149 },
  { "name": "Milton Plastic Cold Drink Bottle", "price": 199 },
  { "name": "Pigeon Plastic Glue Bottle", "price": 99 },
  { "name": "AmazonBasics Plastic Detergent Bottle", "price": 249 },
  { "name": "Signoraware Plastic Milk Bottle", "price": 199 },
  { "name": "Tupperware Plastic Juice Bottle", "price": 349 },
  { "name": "Cello Plastic Sipper Bottle", "price": 299 },
  { "name": "Kuber Industries Plastic Flower Vase", "price": 399 },
  { "name": "Nilkamal Plastic Wall Clock", "price": 599 },
  { "name": "AmazonBasics Plastic Photo Frame", "price": 499 },
  { "name": "Milton Plastic Raincoat", "price": 699 },
  { "name": "Pigeon Plastic Coaster Set", "price": 199 },
  { "name": "Signoraware Plastic Watch Organizer", "price": 499 },
  { "name": "Cello Plastic Racquet Toy", "price": 349 },
  { "name": "Kuber Industries Plastic Shelf", "price": 899 },
  { "name": "Nilkamal Plastic Gloves (Pack of 100)", "price": 299 },
  { "name": "AmazonBasics Plastic Card Holder", "price": 199 },
  { "name": "Milton Plastic Tarpaulin Sheet", "price": 799 },
  { "name": "Pigeon Plastic Kiddie Pool", "price": 999 },
  { "name": "Signoraware Plastic Suitcase", "price": 1499 },
  { "name": "Cello Plastic Car Organizer", "price": 599 },
  { "name": "Kuber Industries Plastic Teabag Holder", "price": 149 },
  { "name": "Nilkamal Plastic Helmet", "price": 899 },
  { "name": "AmazonBasics Plastic Shower Curtain", "price": 499 },
  { "name": "Milton Plastic Music Instrument Toy", "price": 399 },
  { "name": "Pigeon Plastic Button Set (100 pcs)", "price": 199 },
  { "name": "Signoraware Plastic Bench", "price": 999 },
  { "name": "Cello Plastic Board Game Set", "price": 599 },
  { "name": "Kuber Industries Plastic Fan", "price": 799 },
  { "name": "Nilkamal Plastic PVC Pipe 10ft", "price": 299 },
  { "name": "AmazonBasics Plastic Eyeglass Frame", "price": 499 },
  { "name": "Milton Plastic Makeup Organizer", "price": 699 },
  { "name": "Pigeon Plastic Folder Set (5 pcs)", "price": 349 },
  { "name": "Signoraware Plastic Wrapper Roll", "price": 199 },
  { "name": "Cello Plastic Chair Cover", "price": 299 },
  { "name": "Kuber Industries Plastic TV Cover", "price": 399 },
  { "name": "Nilkamal Plastic Sofa Cover", "price": 499 },
  { "name": "AmazonBasics Plastic Coat Cover", "price": 349 },
  { "name": "Milton Plastic Dry-Clean Cover", "price": 299 },
  { "name": "Pigeon Plastic Medicine Box", "price": 249 },
  { "name": "Signoraware Plastic Packet Organizer", "price": 199 },
  { "name": "Cello Plastic Cooler", "price": 1499 },
  { "name": "Kuber Industries Plastic Legos Toy Set", "price": 599 },
  { "name": "Nilkamal Plastic Sporting Equipment Kit", "price": 999 },
  { "name": "AmazonBasics Plastic Wall Hanging Decor", "price": 499 },
  { "name": "Milton Plastic Decorative Tree", "price": 399 },
  { "name": "Pigeon Plastic Flower Garland", "price": 299 },
  { "name": "Signoraware Plastic Confetti Pack", "price": 149 },
  { "name": "Cello Plastic Jewelry Organizer", "price": 599 },


  { "name": "Nilkamal Plastic Crate 25L", "price": 499 },
  { "name": "Cello Swing Plastic Bin 15L", "price": 349 },
  { "name": "Milton Marvel Plastic Jug 2L", "price": 229 },
  { "name": "Pigeon Plastic Storage Box 10L", "price": 399 },
  { "name": "Kuber Industries Plastic Rack 4-Tier", "price": 899 },
  { "name": "Signoraware Plastic Lunch Box Set", "price": 599 },
  { "name": "AmazonBasics Plastic Drawer Set", "price": 999 },
  { "name": "Tupperware Plastic Mixing Bowl Set", "price": 799 },
  { "name": "Cello Plastic Chair Premium", "price": 1499 },
  { "name": "Supreme Plastic Table Compact", "price": 999 },
  { "name": "Nilkamal Plastic Shoe Cabinet", "price": 1799 },
  { "name": "Kuber Industries Plastic Hanger Pack", "price": 199 },
  { "name": "Milton Plastic Bathroom Set (6 pcs)", "price": 699 },
  { "name": "Pigeon Plastic Planter Pot Set", "price": 499 },
  { "name": "Cello Plastic Mop Bucket Deluxe", "price": 849 },
  { "name": "Scotch-Brite Plastic Dustpan Pro", "price": 179 },
  { "name": "Signoraware Plastic Ice Tray Duo", "price": 199 },
  { "name": "AmazonBasics Plastic Cutlery Tray", "price": 349 },
  { "name": "Tupperware Plastic Food Tray Set", "price": 599 },
  { "name": "Milton Plastic Water Bottle 1L", "price": 149 },
  { "name": "Pigeon Plastic Cold Drink Bottle", "price": 199 },
  { "name": "Kuber Industries Plastic Flower Vase", "price": 399 },
  { "name": "Nilkamal Plastic Wall Clock Modern", "price": 599 },
  { "name": "AmazonBasics Plastic Photo Frame A4", "price": 499 },
  { "name": "Milton Plastic Raincoat Adult", "price": 699 },
  { "name": "Pigeon Plastic Coaster Set (6 pcs)", "price": 199 },
  { "name": "Signoraware Plastic Watch Box", "price": 499 },
  { "name": "Cello Plastic Toy Racquet Set", "price": 349 },
  { "name": "Kuber Industries Plastic Shelf 3-Tier", "price": 899 },
  { "name": "Nilkamal Plastic Gloves Pack of 100", "price": 299 },
  { "name": "AmazonBasics Plastic Card Holder", "price": 199 },
  { "name": "Milton Plastic Tarpaulin Sheet 6x8ft", "price": 799 },
  { "name": "Pigeon Plastic Kiddie Pool Round", "price": 999 },
  { "name": "Signoraware Plastic Suitcase Medium", "price": 1499 },
  { "name": "Cello Plastic Car Organizer Tray", "price": 599 },
  { "name": "Kuber Industries Plastic Teabag Box", "price": 149 },
  { "name": "Nilkamal Plastic Helmet Youth", "price": 899 },
  { "name": "AmazonBasics Plastic Shower Curtain", "price": 499 },
  { "name": "Milton Plastic Music Toy Drum", "price": 399 },
  { "name": "Pigeon Plastic Button Pack (100 pcs)", "price": 199 },
  { "name": "Signoraware Plastic Bench Outdoor", "price": 999 },
  { "name": "Cello Plastic Board Game Organizer", "price": 599 },
  { "name": "Kuber Industries Plastic Fan Mini", "price": 799 },
  { "name": "Nilkamal Plastic PVC Pipe 10ft", "price": 299 },
  { "name": "AmazonBasics Plastic Eyeglass Frame", "price": 499 },
  { "name": "Milton Plastic Makeup Box", "price": 699 },
  { "name": "Pigeon Plastic Folder Set (5 pcs)", "price": 349 },
  { "name": "Signoraware Plastic Wrapper Roll", "price": 199 },
  { "name": "Cello Plastic Chair Cover Set", "price": 299 },
  { "name": "Kuber Industries Plastic TV Cover", "price": 399 },
  { "name": "Nilkamal Plastic Sofa Cover", "price": 499 },
  { "name": "AmazonBasics Plastic Coat Cover", "price": 349 },
  { "name": "Milton Plastic Dry-Clean Cover", "price": 299 },
  { "name": "Pigeon Plastic Medicine Box Organizer", "price": 249 },
  { "name": "Signoraware Plastic Packet Holder", "price": 199 },
  { "name": "Cello Plastic Cooler 20L", "price": 1499 },
  { "name": "Kuber Industries Plastic Lego Toy Set", "price": 599 },
  { "name": "Nilkamal Plastic Sports Kit", "price": 999 },
  { "name": "AmazonBasics Plastic Wall Decor Panel", "price": 499 },
  { "name": "Milton Plastic Decorative Tree", "price": 399 },
  { "name": "Pigeon Plastic Flower Garland", "price": 299 },
  { "name": "Signoraware Plastic Confetti Pack", "price": 149 },
  { "name": "Cello Plastic Jewelry Box", "price": 599 },
  { "name": "Kuber Industries Plastic Toy Organizer", "price": 899 },
  { "name": "Nilkamal Plastic Storage Cabinet", "price": 1799 },
  { "name": "AmazonBasics Plastic Kitchen Mat", "price": 349 },
  { "name": "Milton Plastic Dish Rack", "price": 699 },
  { "name": "Pigeon Plastic Measuring Cup Set", "price": 249 },
  { "name": "Signoraware Plastic Spice Rack", "price": 599 },
  { "name": "Cello Plastic Sink Organizer", "price": 399 },


  { "name": "Nilkamal Plastic Utility Crate 35L", "price": 599 },
  { "name": "Cello Swing Bin 20L", "price": 399 },
  { "name": "Milton Marvel Jug 5L", "price": 349 },
  { "name": "Pigeon Storage Box 15L", "price": 499 },
  { "name": "Kuber Industries 5-Tier Plastic Rack", "price": 999 },
  { "name": "Signoraware Executive Lunch Set", "price": 699 },
  { "name": "AmazonBasics Modular Drawer Unit", "price": 1099 },
  { "name": "Tupperware Chef Mixing Bowl Set", "price": 899 },
  { "name": "Cello Comfort Chair", "price": 1599 },
  { "name": "Supreme Compact Table", "price": 1099 },
  { "name": "Nilkamal Shoe Cabinet 3-Door", "price": 1899 },
  { "name": "Kuber Industries Hanger Pack of 20", "price": 249 },
  { "name": "Milton Bathroom Set Deluxe (7 pcs)", "price": 799 },
  { "name": "Pigeon Planter Pot Set of 4", "price": 599 },
  { "name": "Cello Mop Bucket Pro", "price": 899 },
  { "name": "Scotch-Brite Dustpan XL", "price": 199 },
  { "name": "Signoraware Ice Tray Trio", "price": 249 },
  { "name": "AmazonBasics Cutlery Tray Expandable", "price": 399 },
  { "name": "Tupperware Food Tray Duo", "price": 649 },
  { "name": "Milton Aqua Bottle 1.5L", "price": 179 },
  { "name": "Pigeon Chill Bottle 1L", "price": 229 },
  { "name": "Kuber Industries Decorative Vase", "price": 449 },
  { "name": "Nilkamal Wall Clock Designer", "price": 699 },
  { "name": "AmazonBasics Photo Frame Set of 3", "price": 599 },
  { "name": "Milton Raincoat Compact", "price": 749 },
  { "name": "Pigeon Coaster Set Floral (6 pcs)", "price": 249 },
  { "name": "Signoraware Watch Organizer Box", "price": 549 },
  { "name": "Cello Toy Racquet Duo", "price": 399 },
  { "name": "Kuber Industries Shelf 5-Tier", "price": 999 },
  { "name": "Nilkamal Disposable Gloves Pack of 100", "price": 349 },
  { "name": "AmazonBasics Card Holder Slim", "price": 249 },
  { "name": "Milton Tarpaulin Sheet 8x10ft", "price": 899 },
  { "name": "Pigeon Kiddie Pool Oval", "price": 1099 },
  { "name": "Signoraware Suitcase Large", "price": 1599 },
  { "name": "Cello Car Organizer Multi-Pocket", "price": 699 },
  { "name": "Kuber Industries Teabag Organizer", "price": 199 },
  { "name": "Nilkamal Helmet Pro", "price": 999 },
  { "name": "AmazonBasics Shower Curtain Printed", "price": 599 },
  { "name": "Milton Music Toy Set", "price": 449 },
  { "name": "Pigeon Button Pack Assorted (200 pcs)", "price": 249 },
  { "name": "Signoraware Outdoor Bench", "price": 1099 },
  { "name": "Cello Board Game Organizer XL", "price": 699 },
  { "name": "Kuber Industries Mini Fan", "price": 899 },
  { "name": "Nilkamal PVC Pipe 15ft", "price": 399 },
  { "name": "AmazonBasics Eyeglass Frame Classic", "price": 599 },
  { "name": "Milton Makeup Organizer Deluxe", "price": 799 },
  { "name": "Pigeon Folder Set Transparent (6 pcs)", "price": 399 },
  { "name": "Signoraware Wrapper Roll Jumbo", "price": 249 },
  { "name": "Cello Chair Cover Premium", "price": 349 },
  { "name": "Kuber Industries TV Cover Floral", "price": 449 },
  { "name": "Nilkamal Sofa Cover Designer", "price": 599 },
  { "name": "AmazonBasics Coat Cover Pack of 3", "price": 399 },
  { "name": "Milton Dry-Clean Cover XL", "price": 349 },
  { "name": "Pigeon Medicine Box Organizer Pro", "price": 299 },
  { "name": "Signoraware Packet Holder Wall Mount", "price": 249 },
  { "name": "Cello Cooler 25L", "price": 1599 },
  { "name": "Kuber Industries Lego Toy Box", "price": 699 },
  { "name": "Nilkamal Sports Kit Combo", "price": 1099 },
  { "name": "AmazonBasics Wall Decor Panel Set", "price": 599 },
  { "name": "Milton Decorative Tree Mini", "price": 449 },
  { "name": "Pigeon Flower Garland Pack", "price": 349 },
  { "name": "Signoraware Confetti Pack Metallic", "price": 199 },
  { "name": "Cello Jewelry Organizer Box", "price": 699 },
  { "name": "Kuber Industries Toy Organizer Bin", "price": 999 },
  { "name": "Nilkamal Storage Cabinet 4-Door", "price": 1899 },
  { "name": "AmazonBasics Kitchen Mat Anti-Slip", "price": 399 },
  { "name": "Milton Dish Rack Compact", "price": 799 },
  { "name": "Pigeon Measuring Cup Set (6 pcs)", "price": 299 },
  { "name": "Signoraware Spice Rack Carousel", "price": 699 },
  { "name": "Cello Sink Organizer Tray", "price": 449 },



  { "name": "Mforall Dual-Use Oil Sprayer Bottle", "price": 285 },
  { "name": "Artvibes Designer Elephant Wall Hanging", "price": 179 },
  { "name": "COI Sticky Notes Memo Book with Pen", "price": 199 },
  { "name": "GLUN Lint Remover for Woolen Clothes", "price": 199 },
  { "name": "Seznik Mini Packet Sealing Machine", "price": 365 },
  { "name": "Clazkit Plastic Fruit & Pasta Strainer", "price": 54 },
  { "name": "Hallstatt Extendable Ceiling Duster", "price": 289 },
  { "name": "SATYAM KRAFT Penguin Miniature Set", "price": 331 },
  { "name": "CPENSUS Tulip Cube Mirror Lamp", "price": 349 },
  { "name": "ALOXE Cosmetic Organizer Box", "price": 198 },
  { "name": "MOROVIK Mini Packet Sealer", "price": 279 },
  { "name": "Street27 Panda Mobile Stand", "price": 349 },
  { "name": "Street27 Astronaut Figurine Set (3 pcs)", "price": 349 },
  { "name": "One94Store Tulip LED Night Lamp", "price": 599 },
  { "name": "CPENSUS Moving Sand Art Picture Frame", "price": 499 },
  { "name": "StarZebra Hand-Carved Rosewood Jewelry Box", "price": 299 },
  { "name": "Car Dashboard Decoration Set (3 pcs)", "price": 529 },
  { "name": "Beauté Secrets 18pc Manicure Kit", "price": 399 },
  { "name": "Sehaz Artworks Memories Wall Hanging", "price": 249 },
  { "name": "Laxmi Pyramid Gomati Chakra Decor", "price": 599 },
  { "name": "Solimo Think Outside the Box Showpiece", "price": 239 },
  { "name": "ZAHEPA Aeroplane Mini Table Clock", "price": 659 },
  { "name": "Tosaa 18pc Snack Bag Clip Set", "price": 59 },
  { "name": "Oslen 2-in-1 Soap Dispenser & Sponge Holder", "price": 199 },
  { "name": "One94Store Silicone Panda Night Light", "price": 599 },
  { "name": "NYRWANA Astronaut Planet Mug", "price": 499 },
  { "name": "Artvibes MDF Wall Quote Hanger", "price": 239 },
  { "name": "Street27 Thinker Statue Set (4 pcs)", "price": 599 },
  { "name": "WOODEN Calendar with Desk Organizer", "price": 699 },
  { "name": "Glowrite Acrylic LED Writing Board", "price": 795 },
  { "name": "CraftVatika Panda Miniature Decor", "price": 299 },
  { "name": "Bigsmall Astronaut Moon Lamp", "price": 3499 },
  { "name": "Bigsmall Volcano Humidifier", "price": 1999 },
  { "name": "Bigsmall Foldable Cone Light", "price": 899 },
  { "name": "Bigsmall Elephant Incense Burner", "price": 799 },
  { "name": "Bigsmall Vintage Gramophone Speaker", "price": 1899 },
  { "name": "Bigsmall Wooden City Desk Tidy", "price": 1699 },
  { "name": "Bigsmall Spin Shade LED Glass", "price": 699 },
  { "name": "Bigsmall 4-in-1 Speaker & Charger", "price": 2499 },
  { "name": "Bigsmall Automatic Pan Stirrer", "price": 999 },
  { "name": "Bigsmall Vibe Stand Speaker", "price": 1150 },
  { "name": "Bigsmall Rave Shade LED Glass", "price": 699 },
  { "name": "Bigsmall Personalized Gadget Organizer", "price": 1299 },
  { "name": "Giftcart Dexter Reusable Notebook", "price": 799 },
  { "name": "Giftcart Chees Bite Smiley Cushion", "price": 349 },
  { "name": "Giftcart Mini Football Stress Ball", "price": 699 },
  { "name": "Giftcart Bubble Bath Gag Gift", "price": 249 },
  { "name": "Giftcart Straw Hat Gag Gift", "price": 399 },
  { "name": "Giftcart Paperwork Gag Gift", "price": 299 },
  { "name": "Giftcart Hair Dryer Gag Gift", "price": 299 },
  { "name": "Giftcart X Box Gag Gift", "price": 299 },
  { "name": "Giftcart Personalized Lawyer Stand", "price": 249 },
  { "name": "Giftcart Personalized Rock Star Stand", "price": 249 },
  { "name": "Giftcart Personalized Chef Stand", "price": 249 },
  { "name": "Giftcart Personalized Baby Poster", "price": 699 },
  { "name": "Giftcart Personalized What I Love About You Book", "price": 699 },
  { "name": "Giftcart Personalized Lady Doctor Stand", "price": 249 },
  { "name": "Giftcart Personalized Superboy Stand", "price": 249 },
  { "name": "Giftcart Personalized Superman Stand", "price": 249 },
  { "name": "Giftcart Personalized Heart Revolving Frame", "price": 599 },
  { "name": "Giftcart Personalized Pen Sleeve", "price": 399 },
  { "name": "Giftcart Conversation Magnets Set", "price": 499 },
  { "name": "Giftcart Personalized Belle Stand", "price": 249 },
  { "name": "Giftcart Personalized Mom Poster", "price": 699 },
  { "name": "Giftcart Personalized Sister Book", "price": 699 },
  { "name": "Giftcart Personalized Dad Keychain", "price": 399 },
  { "name": "Giftcart Personalized Mark the Date Keychain", "price": 399 },
  { "name": "Giftcart Personalized Couple Mug Set", "price": 450 },
  { "name": "Giftcart Personalized Ceramic Mug", "price": 400 },
  { "name": "Giftcart Personalized Heart Mug", "price": 499 },
   { "name": "Plastic item", "price": 699 },


                  ],

        "Lining, Lace and others": [

      { "name": "HUNNY-BUNCH Lycra Fusing Interlining (5m)", "price": 416 },
  { "name": "TRUEVELLI Rubia Cotton Blouse Fabric (Pack of 10)", "price": 595 },
  { "name": "Unstitched Cotton Astar for Blouse (2m)", "price": 299 },
  { "name": "Blouse Lining Cloth Aster (Pack of 25)", "price": 474 },
  { "name": "M Fabrics Cotton Lining 2by1 (Red, 2m)", "price": 299 },
  { "name": "Pack of 5 Multicolor Pure Cotton Astar", "price": 499 },
  { "name": "Cotton Colors Rubia Blouse Piece (B6)", "price": 299 },
  { "name": "Cotton Colors Rubia Blouse Piece (C296)", "price": 349 },
  { "name": "Rubia Cotton Millennium Blouse Fabric (Pack of 10)", "price": 699 },
  { "name": "Unstitched Cotton Astar (Maroon, 2m)", "price": 299 },
  { "name": "Cotton Blouse Astar (Pack of 12)", "price": 445 },
  { "name": "Cotton Colors Rubia Blouse Piece (D346)", "price": 549 },
  { "name": "Lamoksh Pure Cotton Astar Fabric (5m)", "price": 499 },
  { "name": "Chalostore Pochampally Ikat Blouse Fabric", "price": 299 },
  { "name": "Nilavan's Designer Blouse Materials (Pack of 10)", "price": 399 },
  { "name": "Femina Cotton Blouse Piece Set of 5", "price": 300 },
  { "name": "ILIANA Rubia Blouse Piece Combo (5 pcs)", "price": 385 },
  { "name": "AMBIKA Butter Crape Lining Fabric (Cream, 1m)", "price": 269 },
  { "name": "AMBIKA Pure Cotton Astar (White, 5m)", "price": 499 },
  { "name": "Brocade Blouse Material with Lining", "price": 345 },
  { "name": "Cotton Colors Silk Blouse Piece (Navratri Special)", "price": 450 },
  { "name": "AASHIRWAD Silk Blouse Combo (10 pcs)", "price": 474 },
  { "name": "Cotton Colors Rubia Blouse Piece (CCAC375)", "price": 549 },
  { "name": "Designer Blouse Fabric with Cotton Lining", "price": 999 },
  { "name": "AJ Polycotton Blouse Material (Multicolor)", "price": 69 },
  { "name": "SHRI SHYAM CREATION Brocade Silk Blouse Piece", "price": 499 },
  { "name": "AMBIKA Poplin Fabric for Blouse (Light Pink)", "price": 299 },
  { "name": "Shri Guru Multicolor Blouse Material", "price": 170 },
  { "name": "M Fabrics Cotton Lining Cloth (White, 2m)", "price": 349 },
  { "name": "Kalamkari Hathi Moriya Blouse Material", "price": 350 },
  { "name": "little PANDA South Border Blouse Combo (10 pcs)", "price": 999 },
  { "name": "Garmend Silk-Cotton Blouse Piece", "price": 539 },
  { "name": "Nakoda Textiles Cotton Lining Fabric (36 inch)", "price": 18 },
  { "name": "Meesho Zari Lining Viscose Fabric with Lace Border", "price": 966 },
  { "name": "YASHIKA Lace Saree with Georgette Fabric", "price": 443 },
  { "name": "NIMISHA Gota Work Lace Saree Falls", "price": 186 },
  { "name": "APSARA FASHION Golden Lace Saree Falls", "price": 383 },
  { "name": "Samah Embellished Bandhani Lace Saree", "price": 1149 },
  { "name": "Anand Floral Print Lace Saree", "price": 315 },
  { "name": "APSARA FASHION Cutdana-6L Lace Falls", "price": 476 },
  { "name": "SIFAH Striped Georgette Lace Saree (Pack of 2)", "price": 448 },
  { "name": "Blouse House V-Neck Women Blouse", "price": 426 },
  { "name": "Lacesnmore Hanging Lace Saree Falls", "price": 370 },
  { "name": "Samah Dyed Net Lace Saree", "price": 492 },
  { "name": "Samah Printed Bandhani Lace Saree", "price": 499 },
  { "name": "Anand Saree with Attached Blouse", "price": 475 },
  { "name": "ridhi collection Golden Work Lace Saree", "price": 488 },
  { "name": "SHIVCHKRA Dyed Leheria Lace Saree", "price": 650 },
  { "name": "Pachrangi Multi Gold Lace Combo Pack", "price": 219 },
  { "name": "NIMISHA Multicolor Lace Saree Falls", "price": 193 },
  { "name": "Samah Net Lace Saree (Pink)", "price": 492 },
  { "name": "Samah Bandhani Lace Saree (Red & Green)", "price": 499 },
  { "name": "YASHIKA Bollywood Georgette Lace Saree", "price": 398 },
  { "name": "YASHIKA Bandhani Georgette Lace Saree", "price": 443 },
  { "name": "YASHIKA Daily Wear Lace Saree (Green)", "price": 442 },
  { "name": "YASHIKA Printed Lace Saree (Purple)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Multicolor)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Blue)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Orange)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Red)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Maroon)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Yellow)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Pink)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Brown)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (White)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Black)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Silver)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Gold)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Teal)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Peach)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Lavender)", "price": 443 },

  { "name": "Nakoda Textiles Cotton Lining Fabric (White, 36 inch)", "price": 18 },
  { "name": "Meesho Pure Padding Viscose Fabric with Zari Lining", "price": 966 },
  { "name": "SHRI SHYAM CREATION Brocade Silk Blouse Piece with Golden Jari", "price": 499 },
  { "name": "TRUEVELLI Rubia Cotton Millennium Blouse Fabric (Pack of 10)", "price": 699 },
  { "name": "Cotton Colors Rubia Blouse Piece (CCAC375)", "price": 549 },
  { "name": "AMBIKA Butter Crape Lining Fabric (Cream, 1m)", "price": 269 },
  { "name": "ILIANA Rubia Blouse Piece Combo (5 pcs)", "price": 385 },
  { "name": "Chalostore Pochampally Ikat Blouse Fabric", "price": 299 },
  { "name": "Designer Blouse Fabric with Cotton Lining", "price": 999 },
  { "name": "little PANDA South Border Blouse Combo (10 pcs)", "price": 999 },
  { "name": "Garmend Silk-Cotton Blouse Piece", "price": 539 },
  { "name": "Kalamkari Hathi Moriya Blouse Material", "price": 350 },
  { "name": "AMBIKA Poplin Fabric for Blouse (Light Pink)", "price": 299 },
  { "name": "Cotton Colors Silk Blouse Piece (Navratri Special)", "price": 450 },
  { "name": "AASHIRWAD Silk Blouse Combo (10 pcs)", "price": 474 },
  { "name": "APSARA FASHION Golden Lace Saree Falls", "price": 383 },
  { "name": "Samah Embellished Bandhani Lace Saree", "price": 1149 },
  { "name": "Anand Floral Print Lace Saree", "price": 315 },
  { "name": "APSARA FASHION Cutdana-6L Lace Falls", "price": 476 },
  { "name": "SIFAH Striped Georgette Lace Saree (Pack of 2)", "price": 448 },
  { "name": "Blouse House V-Neck Women Blouse", "price": 426 },
  { "name": "Lacesnmore Hanging Lace Saree Falls", "price": 370 },
  { "name": "Samah Dyed Net Lace Saree", "price": 492 },
  { "name": "Samah Printed Bandhani Lace Saree", "price": 499 },
  { "name": "Anand Saree with Attached Blouse", "price": 475 },
  { "name": "ridhi collection Golden Work Lace Saree", "price": 488 },
  { "name": "SHIVCHKRA Dyed Leheria Lace Saree", "price": 650 },
  { "name": "Pachrangi Multi Gold Lace Combo Pack", "price": 219 },
  { "name": "NIMISHA Multicolor Lace Saree Falls", "price": 193 },
  { "name": "YASHIKA Bollywood Georgette Lace Saree", "price": 398 },
  { "name": "YASHIKA Bandhani Georgette Lace Saree", "price": 443 },
  { "name": "YASHIKA Daily Wear Lace Saree (Green)", "price": 442 },
  { "name": "YASHIKA Printed Lace Saree (Purple)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Multicolor)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Blue)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Orange)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Red)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Maroon)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Yellow)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Pink)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Brown)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (White)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Black)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Silver)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Gold)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Teal)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Peach)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Lavender)", "price": 443 },
  { "name": "APSARA FASHION 9 Meter Golden Lace", "price": 383 },
  { "name": "Samah Printed Bandhani Georgette Lace Saree", "price": 491 },
  { "name": "Anand Sarees Floral Print Lace Saree", "price": 475 },
  { "name": "Samah Net Lace Saree (Pink)", "price": 492 },
  { "name": "Samah Bandhani Lace Saree (Red & Green)", "price": 499 },
  { "name": "YASHIKA Printed Lace Saree (Sky Blue)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Mint Green)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Rose)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Charcoal)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Beige)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Turquoise)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Coral)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Mustard)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Olive)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Wine)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Ivory)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Champagne)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Copper)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Bronze)", "price": 443 },
  { "name": "YASHIKA Printed Lace Saree (Emerald)", "price": 443 },


  { "name": "Kairavi Golden Nalki Lace (9m)", "price": 397 },
  { "name": "PRANSUNITA Zarkan Rhinestone Buttons (20mm)", "price": 290 },
  { "name": "Decorama Gota Patti Paisley Booti Appliques (Pack of 20)", "price": 249 },
  { "name": "Lovetholy Embroidery Neck Applique Patches (25 pcs)", "price": 399 },
  { "name": "Decorama Handmade Gota Flowers (Gold, Pack of 10)", "price": 149 },
  { "name": "Lovetholy Zardosi Flower Patches (25 pcs)", "price": 379 },
  { "name": "Aerene Moti Lace Silver (9m)", "price": 249 },
  { "name": "Craftlove Pearl & Gold Latkan Lace (8.5m)", "price": 749 },
  { "name": "UE Peacock Design Zari Applique (Light Pink)", "price": 595 },
  { "name": "MS Zariwala Katdana Nalki Lace (4.5m)", "price": 399 },
  { "name": "VINAYAK GALLERY Pipe-in-Net Lace (9m)", "price": 361 },
  { "name": "Asian Hobby Crafts Ribbon Rose Flowers (Pack of 24)", "price": 225 },
  { "name": "PRANSUNITA Pom Pom Ghungroo Tassels (50 pcs)", "price": 290 },
  { "name": "Lovetholy Peacock Sew-On Patches (2 pcs)", "price": 299 },
  { "name": "Applique Round Kundan Butties (Set of 25)", "price": 299 },
  { "name": "Decorama Radha Krishna Embroidery Patches (Pack of 20)", "price": 399 },
  { "name": "Paushak Boutique Embroidery Neck Patch", "price": 349 },
  { "name": "Lovetholy Floral Neck Applique Patches (11 pcs)", "price": 349 },
  { "name": "Lovetholy Blue Neck Applique Patches (25 pcs)", "price": 399 },
  { "name": "Decorama Flower Cutwork Lace Border (9m)", "price": 248 },
  { "name": "Lovetholy Round Shape Applique Patches (50 pcs)", "price": 344 },
  { "name": "Decorama Zari Work Mango Applique (25 pcs)", "price": 379 },
  { "name": "UE Handmade Dark Green Applique Patches (10 pcs)", "price": 299 },
  { "name": "UE Pineapple Shape Golden Appliques (15 pcs)", "price": 299 },
  { "name": "Artificial Pearl & Jarkan Patches (25 pcs)", "price": 299 },
  { "name": "Delush Design Kundan Stones (600 pcs)", "price": 249 },
  { "name": "aanya Golden Pearl & Beads Lace (9m)", "price": 420 },
  { "name": "80M Samosa Gota Patti Lace (40m x 2 rolls)", "price": 299 },
  { "name": "9mm Mirror Hanging Tassel Lace (9m)", "price": 179 },
  { "name": "UE Maggam Work Peacock Zari Patch", "price": 595 },
  { "name": "UE Maggam Work Unique Red Zari Patch", "price": 697 },
  { "name": "Lovetholy Peach Neck Applique Patches (11 pcs)", "price": 349 },
  { "name": "Lovetholy Embroidery Neck Patches (Blue, 25 pcs)", "price": 399 },
  { "name": "Decorama Gota Patti Flower Patches (Gold, Pack of 10)", "price": 149 },
  { "name": "Lovetholy Zardosi Patch Work Flowers (25 pcs)", "price": 379 },
  { "name": "Decorama Handmade Paisley Booti Appliques (Red, Pack of 20)", "price": 249 },
  { "name": "Lovetholy Embroidery Neck Sew-On Flowers (11 pcs)", "price": 349 },
  { "name": "Lovetholy Peacock Embroidery Patches (2 pcs)", "price": 299 },
  { "name": "Lovetholy Decorative Round Kundan Butties (25 pcs)", "price": 299 },
  { "name": "Lovetholy Floral Design Zardosi Patches (25 pcs)", "price": 379 },
  { "name": "Lovetholy Designer Neck Patches (Pack of 25)", "price": 333 },
  { "name": "Lovetholy Embroidery Neck Patches (Pack of 25)", "price": 269 },
  { "name": "Lovetholy Decorative Patches for Saree (Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Peacock Feather Patches (25 pcs)", "price": 379 },
  { "name": "Lovetholy Embroidery Neck Patches (Red, 25 pcs)", "price": 299 },
  { "name": "Lovetholy Decorative Patches for Blouse (Pack of 25)", "price": 299 },
  { "name": "Lovetholy Zardosi Flower Design Patches (25 pcs)", "price": 379 },
  { "name": "Lovetholy Embroidery Neck Patches (Multicolor, 25 pcs)", "price": 299 },
  { "name": "Lovetholy Designer Floral Patches (Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Neck Patches (Green, 25 pcs)", "price": 299 },
  { "name": "Lovetholy Decorative Patches (Golden, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Neck Patches (Blue, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Neck Patches (Pink, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patches (Silver, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Neck Patches (Yellow, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Neck Patches (Lavender, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patches (Teal, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Neck Patches (Peach, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Neck Patches (Ivory, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patches (Champagne, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Neck Patches (Copper, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Neck Patches (Bronze, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patches (Emerald, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Neck Patches (Charcoal, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Neck Patches (Rose, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patches (Mint Green, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Neck Patches (Sky Blue, Pack of 25)", "price": 299 },


  { "name": "Kairavi Velvet Zari Border Lace (9m)", "price": 499 },
  { "name": "PRANSUNITA Crystal Button Set (Pack of 12)", "price": 349 },
  { "name": "Decorama Gota Patti Leaf Appliques (Pack of 20)", "price": 299 },
  { "name": "Lovetholy Embroidery Neckline Patch (Gold, 5 pcs)", "price": 399 },
  { "name": "Craftvilla Pearl Latkan Tassels (Set of 6)", "price": 449 },
  { "name": "UE Peacock Zari Patch (Royal Blue)", "price": 599 },
  { "name": "MS Zariwala Katdana Lace Border (5m)", "price": 399 },
  { "name": "VINAYAK GALLERY Net Lace with Sequins (9m)", "price": 379 },
  { "name": "Asian Hobby Crafts Satin Ribbon Roses (Pack of 24)", "price": 225 },
  { "name": "PRANSUNITA Ghungroo Tassel Set (Pack of 10)", "price": 299 },
  { "name": "Lovetholy Floral Neckline Patch (Red, 5 pcs)", "price": 349 },
  { "name": "Applique Kundan Butti Set (Pack of 25)", "price": 299 },
  { "name": "Decorama Radha Krishna Embroidery Patch (Pair)", "price": 399 },
  { "name": "Paushak Boutique Designer Neck Patch (Beige)", "price": 349 },
  { "name": "Lovetholy Zardosi Peacock Patch (2 pcs)", "price": 299 },
  { "name": "Decorama Cutwork Lace Border (Gold, 9m)", "price": 499 },
  { "name": "Lovetholy Round Mirror Appliques (Pack of 50)", "price": 344 },
  { "name": "UE Handmade Zari Mango Patch (Pack of 10)", "price": 299 },
  { "name": "Artificial Pearl & Stone Patch (Pack of 25)", "price": 299 },
  { "name": "Delush Design Crystal Kundan Stones (Pack of 600)", "price": 249 },
  { "name": "aanya Golden Beads & Pearl Lace (9m)", "price": 420 },
  { "name": "Samosa Gota Patti Lace Roll (40m)", "price": 299 },
  { "name": "Mirror Hanging Tassel Lace (Silver, 9m)", "price": 179 },
  { "name": "UE Maggam Work Zari Patch (Emerald)", "price": 595 },
  { "name": "Lovetholy Designer Neck Patch (Lavender, 5 pcs)", "price": 349 },
  { "name": "Decorama Gota Patti Flower Patch (Pink, Pack of 10)", "price": 149 },
  { "name": "Lovetholy Zardosi Floral Patch (Pack of 25)", "price": 379 },
  { "name": "Decorama Paisley Booti Appliques (Gold, Pack of 20)", "price": 249 },
  { "name": "Lovetholy Embroidery Neck Patch (Sky Blue, 5 pcs)", "price": 349 },
  { "name": "Lovetholy Peacock Feather Patch (Pack of 2)", "price": 299 },
  { "name": "Lovetholy Kundan Butti Patch (Pack of 25)", "price": 299 },
  { "name": "Lovetholy Zardosi Leaf Patch (Pack of 25)", "price": 379 },
  { "name": "Lovetholy Designer Neck Patch (Champagne, Pack of 5)", "price": 333 },
  { "name": "Lovetholy Embroidery Neck Patch (Mint Green, Pack of 5)", "price": 269 },
  { "name": "Lovetholy Decorative Patch for Saree (Pack of 25)", "price": 299 },
  { "name": "Lovetholy Peacock Applique Patch (Multicolor, Pack of 2)", "price": 379 },
  { "name": "Lovetholy Floral Patch for Blouse (Pack of 25)", "price": 299 },
  { "name": "Lovetholy Zardosi Patch (Rose Gold, Pack of 25)", "price": 379 },
  { "name": "Lovetholy Embroidery Patch (Ivory, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Patch (Copper, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Patch (Bronze, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patch (Emerald, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Patch (Charcoal, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Patch (Peach, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patch (Turquoise, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Patch (Teal, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Patch (Coral, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patch (Mustard, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Patch (Olive, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Patch (Wine, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patch (Ivory, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Patch (Champagne, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Patch (Copper, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patch (Bronze, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Patch (Emerald, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Patch (Charcoal, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patch (Rose, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Patch (Mint Green, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Patch (Sky Blue, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patch (Beige, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Patch (Turquoise, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Patch (Coral, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Decorative Patch (Mustard, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Designer Patch (Olive, Pack of 25)", "price": 299 },
  { "name": "Lovetholy Embroidery Patch (Wine, Pack of 25)", "price": 299 },
   { "name": "Lining", "price": 199 },
   { "name": "Blouse piece", "price": 299 },
   { "name": "Lace", "price": 199 },
   { "name": "Lungi", "price": 599 },
   { "name": "Dhothies", "price": 799 },



                  ],
        "Toys and Sports kit": [

            { "name": "Cricket set", "price": 2400 },
            { "name": "Carrom Board", "price": 1400 },
            { "name": "Chess Board", "price": 900 },
            { "name": "Tennis/Shuttle", "price": 1200 },
            { "name": "Foot Ball", "price": 700 },
            { "name": "Ball", "price": 200 },

    { "name": "Peppa Pig Soft Toy", "price": 799 },
  { "name": "Winkon Construction Vehicle Set (6 pcs)", "price": 5220 },
  { "name": "N2J2 Friction Power Truck with Light & Sound", "price": 1195 },
  { "name": "Mini Pull Back Car Set (12 pcs)", "price": 250 },
  { "name": "Raj Toy Store Wooden Arithmetic Box", "price": 1099 },
  { "name": "LEGO Creator Expert Roller Coaster", "price": 29999 },
  { "name": "Hot Wheels Ultimate Garage Playset", "price": 8999 },
  { "name": "Barbie Dreamhouse Doll Set", "price": 12499 },
  { "name": "NERF Elite Blaster Pack", "price": 3499 },
  { "name": "Fisher-Price Laugh & Learn Smart Stages Chair", "price": 2999 },
  { "name": "Melissa & Doug Wooden Railway Set", "price": 4999 },
  { "name": "LeapFrog Magic Adventures Globe", "price": 7999 },
  { "name": "VTech Kidizoom Smartwatch DX3", "price": 4999 },
  { "name": "Crayola Light-Up Tracing Pad", "price": 1899 },
  { "name": "Play-Doh Kitchen Creations Ice Cream Station", "price": 1499 },
  { "name": "Magna-Tiles Clear Colors 100-Piece Set", "price": 8999 },
  { "name": "Smartivity STEM Marble Slide", "price": 1599 },
  { "name": "Osmo Genius Starter Kit for iPad", "price": 9999 },
  { "name": "Robo Wunderkind Explorer Kit", "price": 14999 },
  { "name": "Hape Pound & Tap Bench with Xylophone", "price": 1999 },
  { "name": "Clementoni Science Museum Chemistry Lab", "price": 2499 },
  { "name": "Smartivity Hydraulic Crane STEM Toy", "price": 1799 },
  { "name": "Skillmatics Guess in 10 Animal Planet", "price": 499 },
  { "name": "VTech Touch & Learn Activity Desk", "price": 6999 },
  { "name": "Fisher-Price Code-a-Pillar Twist", "price": 3999 },
  { "name": "Melissa & Doug Deluxe Wooden Stamp Set", "price": 1299 },
  { "name": "Smartivity Mechanical Hand STEM Kit", "price": 1499 },
  { "name": "Skillmatics Card Game - Found It!", "price": 399 },
  { "name": "LeapFrog LeapStart Learning System", "price": 3499 },
  { "name": "Smartivity Music Machine STEM Kit", "price": 1699 },
  { "name": "Crayola Scribble Scrubbie Pets", "price": 999 },
  { "name": "PlayShifu Tacto Chess Interactive Game", "price": 2999 },
  { "name": "Fisher-Price Little People Caring for Animals Farm", "price": 3499 },
  { "name": "LEGO Technic Bugatti Chiron", "price": 16999 },
  { "name": "Smartivity Gear Propeller Flying Machine", "price": 1399 },
  { "name": "Skillmatics Brain Games for Kids", "price": 499 },
  { "name": "Melissa & Doug Wooden Shape Sorting Cube", "price": 999 },
  { "name": "LeapFrog My Pal Scout", "price": 2499 },
  { "name": "VTech Write & Learn Creative Center", "price": 2999 },
  { "name": "Smartivity DIY Microscope STEM Kit", "price": 1899 },
  { "name": "Skillmatics Educational Game - Space Explorers", "price": 499 },
  { "name": "Play-Doh Super Color Pack (20 cans)", "price": 999 },
  { "name": "Crayola Washable Sidewalk Chalk (48 pcs)", "price": 799 },
  { "name": "Melissa & Doug Wooden Pizza Party Set", "price": 1499 },
  { "name": "Smartivity DIY Telescope STEM Kit", "price": 1999 },
  { "name": "Skillmatics Educational Game - World of Animals", "price": 499 },
  { "name": "LeapFrog Learning Friends 100 Words Book", "price": 2499 },
  { "name": "VTech Musical Rhymes Book", "price": 1999 },
  { "name": "Smartivity DIY Periscope STEM Kit", "price": 1499 },
  { "name": "Skillmatics Educational Game - Guess in 10 Countries", "price": 499 },
  { "name": "PlayShifu Orboot Earth AR Globe", "price": 2999 },
  { "name": "Fisher-Price Laugh & Learn Smart Stages Piggy Bank", "price": 1499 },
  { "name": "Melissa & Doug Wooden Animal Magnets", "price": 999 },
  { "name": "Smartivity DIY Kaleidoscope STEM Kit", "price": 1399 },
  { "name": "Skillmatics Educational Game - Animal Kingdom", "price": 499 },
  { "name": "LeapFrog Scout's Learning Lights Remote", "price": 1499 },
  { "name": "VTech Spin & Learn Color Flashlight", "price": 1299 },
  { "name": "Smartivity DIY Catapult STEM Kit", "price": 1599 },
  { "name": "Skillmatics Educational Game - Brain Games", "price": 499 },
  { "name": "Play-Doh Wheels Firetruck Playset", "price": 1299 },
  { "name": "Crayola Color Wonder Mess-Free Coloring Set", "price": 999 },
  { "name": "Melissa & Doug Wooden Lacing Beads", "price": 1299 },
  { "name": "Smartivity DIY Safe Vault STEM Kit", "price": 1799 },
  { "name": "Skillmatics Educational Game - Countries of the World", "price": 499 },
  { "name": "LeapFrog Count Along Cash Register", "price": 2999 },
  { "name": "VTech Busy Learners Activity Cube", "price": 3499 },
  { "name": "Smartivity DIY Hydraulic Lift STEM Kit", "price": 1899 },
  { "name": "Skillmatics Educational Game - Pre-Math & Numbers", "price": 499 },


  { "name": "Toyshine Junior Cricket Set with Bat, Ball & Stumps", "price": 499 },
  { "name": "Jaspo Dominator Venom Edition Cricket Bat + Ball", "price": 524 },
  { "name": "Boldfit Turf Bat Full Size for Tennis Ball", "price": 349 },
  { "name": "Cockatoo Destructor Complete Cricket Kit", "price": 999 },
  { "name": "Play Nation Premium Junior Cricket Set", "price": 299 },
  { "name": "GRS KidsZone Willow Bat with Wicket Set", "price": 439 },
  { "name": "Nippon Baby Cricket Bat Ball Set", "price": 270 },
  { "name": "JRS AVS Tennis Cricket Bat with Ball", "price": 499 },
  { "name": "PMG Wooden Cricket Bat with Ball & Cap", "price": 499 },
  { "name": "Lifelong Poplar Wood Tennis Ball Bat", "price": 1099 },
  { "name": "Toy Imagine Table Tennis Trainer Kit", "price": 398 },
  { "name": "Ratna's Table Tennis Penguin Set", "price": 129 },
  { "name": "TIMA Hanging Leather Cricket Ball", "price": 309 },
  { "name": "Leader Sportz Smash Foam Bat & Ball Set", "price": 741 },
  { "name": "HighRoof Plastic Cricket Kit for Kids", "price": 299 },
  { "name": "FELIDAE Full Size Bat + Wicket Set + Ball", "price": 699 },
  { "name": "Toy Imagine Indoor Hanging TT Trainer", "price": 398 },
  { "name": "TINEE Hula Hoop for Kids", "price": 299 },
  { "name": "PlayMagic Archery Set with Bow & Dart", "price": 597 },
  { "name": "BKDT Bowling Set with 10 Pins & 2 Balls", "price": 290 },
  { "name": "CrazyBuy Bouncing Moon Ball", "price": 243 },
  { "name": "Bestie Toys Crazy Moon Bounce Ball", "price": 179 },
  { "name": "Toyo TT Cricket Bat", "price": 299 },
  { "name": "Toyo TY00* Cricket Bat", "price": 320 },
  { "name": "Toyo TT012012 Cricket Bat", "price": 499 },
  { "name": "SR Toys Archery Kit", "price": 258 },
  { "name": "S TOYS HOUSE Blue Archery Set", "price": 373 },
  { "name": "S TOYS HOUSE Archery Set", "price": 373 },
  { "name": "Toyo T00OO12* Cricket Bat", "price": 499 },
  { "name": "Toyo TT00*12 Cricket Bat", "price": 399 },
  { "name": "Toyo TOOOYOOO Cricket Bat", "price": 320 },
  { "name": "Toyo TOYOO Cricket Bat", "price": 220 },
  { "name": "Toyo *TY* Cricket Bat", "price": 230 },
  { "name": "Tarak Marvel Spider-Man Bowling Set", "price": 344 },
  { "name": "Space Age Moon Ball Throwball", "price": 250 },
  { "name": "Ratnas Junior Pom Pom Mickey Basketball", "price": 156 },
  { "name": "JASSIA RC Stunt Car Foosball", "price": 822 },
  { "name": "Giftoshopee Softball", "price": 140 },
  { "name": "333MART Big Bowling Game Set", "price": 1215 },
  { "name": "Aditi Toys Plastic Bowling Set", "price": 478 },
  { "name": "Toybharat Ping Pong 3 Ball Play Set", "price": 353 },
  { "name": "SABIRAT Kids Football Play Set", "price": 1498 },
  { "name": "Aditi Toys Pull Back Bow & Arrow", "price": 666 },
  { "name": "Planet of Toys Heavy Duty Bow Arrow Set", "price": 500 },
  { "name": "Amitasha ArcheryPro Bow & Arrow Set", "price": 300 },
  { "name": "DIKUJI ENTERPRISE Bouncing Moon Ball", "price": 217 },
  { "name": "KrocieToys MOON BALL Crazy Ball", "price": 89 },
  { "name": "Synlark Adjustable Basketball Kit", "price": 748 },
  { "name": "333MART Air Hover Soccer Ball", "price": 421 },
  { "name": "ZESTHOME Gravity-Defying Moon Ball", "price": 135 },
  { "name": "SARASI Kids Football Shoot & Score Set", "price": 1499 },
  { "name": "AKANSHA Jumping Balls Multicolor", "price": 288 },
  { "name": "little toys Portable Gulel Catapult Toy", "price": 169 },
  { "name": "PlayKith Wooden Foosball Table", "price": 1326 },
  { "name": "Aditi Toys Crazy Bouncing Balls Jar", "price": 199 },
  { "name": "sarvda Indoor/Outdoor Basketball", "price": 345 },
  { "name": "Planet of Toys Bow Arrow Set", "price": 500 },
  { "name": "LA Toys Lightweight Moon Ball", "price": 161 },
  { "name": "Zenex Binocular Telescope Toy", "price": 210 },
  { "name": "Mallexo Night Glow Handball", "price": 241 },
  { "name": "Ratnas Mini Shot Unicorn Pom Pom", "price": 193 },
  { "name": "TRICKS TOY Sling Puck 3-in-1 Game", "price": 650 },
  { "name": "MINIKIDZ Bowling Set with 6 Pins", "price": 245 },
  { "name": "Kp Enterprise Foam Blaster Toy Gun", "price": 245 },
  { "name": "CrazyBuy Soft Rubber Moon Ball", "price": 243 },
  { "name": "luzzo Softball", "price": 179 },
  { "name": "Ratnas Pom Pom Spiderman Basketball", "price": 164 },
  { "name": "Maanit Crazy Ball", "price": 411 },
  { "name": "Toyo Cricket Kit", "price": 285 },
  { "name": "Anika Kids Hockey Set", "price": 348 },


  { "name": "Toyshine Foam Cricket Bat & Ball Set", "price": 379 },
  { "name": "Jaspo Slog Tennis Cricket Bat", "price": 429 },
  { "name": "Lifelong Poplar Wood Bat for Adults", "price": 1199 },
  { "name": "GRS KidsZone Willow Bat with Wicket Set", "price": 439 },
  { "name": "Toy Imagine Indoor Table Tennis Trainer", "price": 398 },
  { "name": "Ratnas Junior Penguin TT Set", "price": 129 },
  { "name": "TIMA Hanging Leather Practice Ball", "price": 309 },
  { "name": "Leader Sportz Smash Foam Bat & Ball", "price": 741 },
  { "name": "HighRoof Plastic Cricket Kit", "price": 299 },
  { "name": "FELIDAE Full Size Bat & Wicket Set", "price": 699 },
  { "name": "TINEE Kids Hula Hoop", "price": 299 },
  { "name": "PlayMagic Archery Set with Bow & Dart", "price": 597 },
  { "name": "BKDT Bowling Set with Pins & Balls", "price": 290 },
  { "name": "CrazyBuy Bouncing Moon Ball", "price": 243 },
  { "name": "Bestie Toys Crazy Bounce Ball", "price": 179 },
  { "name": "Toyo TT Cricket Bat", "price": 299 },
  { "name": "Toyo TY00* Cricket Bat", "price": 320 },
  { "name": "Toyo TT012012 Cricket Bat", "price": 499 },
  { "name": "SR Toys Archery Kit", "price": 258 },
  { "name": "S TOYS HOUSE Blue Archery Set", "price": 373 },
  { "name": "Tarak Spider-Man Bowling Set", "price": 344 },
  { "name": "Space Age Moon Ball Throwball", "price": 250 },
  { "name": "Ratnas Mickey Basketball", "price": 156 },
  { "name": "JASSIA RC Stunt Car Foosball", "price": 822 },
  { "name": "Giftoshopee Softball", "price": 140 },
  { "name": "333MART Big Bowling Game Set", "price": 1215 },
  { "name": "Aditi Toys Plastic Bowling Set", "price": 478 },
  { "name": "Toybharat Ping Pong Ball Play Set", "price": 353 },
  { "name": "SABIRAT Football Shoot & Score Kit", "price": 1498 },
  { "name": "Aditi Toys LED Bow & Arrow", "price": 666 },
  { "name": "Planet of Toys Heavy Duty Bow Set", "price": 500 },
  { "name": "Amitasha ArcheryPro Bow & Arrow", "price": 300 },
  { "name": "DIKUJI Moon Ball", "price": 217 },
  { "name": "KrocieToys Lightweight Moon Ball", "price": 89 },
  { "name": "Synlark Adjustable Basketball Kit", "price": 748 },
  { "name": "333MART Air Hover Soccer Ball", "price": 421 },
  { "name": "ZESTHOME Gravity-Defying Moon Ball", "price": 135 },
  { "name": "AKANSHA Jumping Balls", "price": 288 },
  { "name": "little toys Portable Gulel Catapult", "price": 169 },
  { "name": "PlayKith Wooden Foosball Table", "price": 1326 },
  { "name": "Aditi Toys Bouncing Balls Jar", "price": 199 },
  { "name": "sarvda Indoor/Outdoor Basketball", "price": 345 },
  { "name": "LA Toys Lightweight Moon Ball", "price": 161 },
  { "name": "Zenex Binocular Telescope Toy", "price": 210 },
  { "name": "Mallexo Night Glow Handball", "price": 241 },
  { "name": "Ratnas Unicorn Pom Pom Shooter", "price": 193 },
  { "name": "TRICKS TOY Sling Puck 3-in-1 Game", "price": 650 },
  { "name": "MINIKIDZ Bowling Set with Pins", "price": 245 },
  { "name": "Kp Enterprise Foam Blaster Gun", "price": 245 },
  { "name": "CrazyBuy Soft Rubber Moon Ball", "price": 243 },
  { "name": "luzzo Softball", "price": 179 },
  { "name": "Ratnas Spiderman Basketball", "price": 164 },
  { "name": "Maanit Crazy Ball", "price": 411 },
  { "name": "Toyo Cricket Kit", "price": 285 },
  { "name": "Anika Kids Hockey Set", "price": 348 },
  { "name": "YUIOP Compact Basketball Console", "price": 250 },
  { "name": "Pumpkin Toys Football", "price": 444 },
  { "name": "KOBBET Table Tennis Trainer", "price": 999 },
  { "name": "R AND P Hanging TT Trainer", "price": 432 },
  { "name": "UB Toys Rechargeable Hoverball", "price": 459 },
  { "name": "SPEEDFOX Kick Scooter", "price": 2057 },
  { "name": "SPEEDFOX Kids Tricycle", "price": 1922 },
  { "name": "Toy Imagine Hanging TT Trainer", "price": 398 },
  { "name": "Toyo TT00*12 Cricket Bat", "price": 399 },
  { "name": "Toyo T00OO12* Cricket Bat", "price": 499 },
  { "name": "Toyo TOOOYOOO Cricket Bat", "price": 320 },
  { "name": "Toyo TOYOO Cricket Bat", "price": 220 },
  { "name": "Toyo *TY* Cricket Bat", "price": 230 },
  { "name": "Planet of Toys Bow Arrow Set", "price": 500 },
  { "name": "TINEE Hula Hoop", "price": 299 },
  { "name": "PlayMagic Archery Set", "price": 597 },
  { "name": "SR Toys Archery", "price": 260 },

  { "name": "Baybee Bronco Battery Operated Jeep (Red)", "price": 7498 },
  { "name": "Little Rides Ride-On Jeep with Bluetooth & Lights", "price": 7999 },
  { "name": "Kidsmate Power Ride Battery Jeep (RGB Lights)", "price": 7499 },
  { "name": "Cockatoo KX-Thar Electric Jeep for Kids", "price": 7499 },
  { "name": "FunBlast Police Jeep Toy with Siren Sound", "price": 265 },
  { "name": "Centy Toys Ranger Pull Back Police Jeep", "price": 132 },
  { "name": "TREXIVO Diecast Thar Jeep Toy (Red)", "price": 299 },
  { "name": "TOYOOS Thar Jeep Premium Car Toy", "price": 299 },
  { "name": "Goods Galaxy Mahindra Thar Diecast Toy", "price": 399 },
  { "name": "JOY JUNCTION Jeep Rubicon Model Car", "price": 999 },
  { "name": "Umadiya Range Rover Defender Model Car", "price": 888 },
  { "name": "SUPER TOY Diecast Thar Jeep (Yellow)", "price": 449 },
  { "name": "Kiddie Galaxia Police Vehicle Play Set", "price": 499 },
  { "name": "Centy Toys Plastic Safari Car", "price": 182 },
  { "name": "AR Toys Diecast Thar Jeep Toy", "price": 299 },
  { "name": "TEC TAVAKKAL Diecast Thar Toy Car", "price": 397 },
  { "name": "COCOBLINC Jeep Wrangler Rubicon Model", "price": 1899 },
  { "name": "BKDT Pull Back Thar Car Toy (Yellow)", "price": 378 },
  { "name": "Toys Treasure Defender Diecast Jeep", "price": 299 },
  { "name": "GKNEX Wrangler Rubicon Diecast Toy", "price": 999 },
  { "name": "Baybee Speedy Ride-On Jeep (Black)", "price": 1998 },
  { "name": "RATNA'S Mini Thar Highway Patrol Jeep", "price": 140 },
  { "name": "Sanghariyat Military Foldable Vehicle Set", "price": 449 },
  { "name": "Baybee Speedy Ride-On Jeep (Green)", "price": 1998 },
  { "name": "Giggles Funskool Police Jeep", "price": 348 },
  { "name": "Iron Man Action Figure with Light & Sound", "price": 799 },
  { "name": "Marvel Avengers Titan Hero Iron Man", "price": 999 },
  { "name": "Iron Man RC Flying Toy", "price": 1299 },
  { "name": "Iron Man Diecast Collectible Figure", "price": 1499 },
  { "name": "Marvel Iron Man Helmet Replica", "price": 4999 },
  { "name": "Iron Man Arm Blaster Toy", "price": 899 },
  { "name": "Marvel Avengers Hero Set (5 pcs)", "price": 1499 },
  { "name": "Iron Man LED Night Lamp Toy", "price": 599 },
  { "name": "Iron Man Puzzle Game Kit", "price": 499 },
  { "name": "Marvel Iron Man Mini Drone", "price": 1999 },
  { "name": "Toyshine Cricket Set with Bat & Ball", "price": 499 },
  { "name": "Jaspo Dominator Cricket Bat + Ball", "price": 524 },
  { "name": "Boldfit Turf Bat Full Size", "price": 349 },
  { "name": "Cockatoo Destructor Cricket Kit", "price": 999 },
  { "name": "Play Nation Junior Cricket Set", "price": 299 },
  { "name": "GRS Willow Bat with Wicket Set", "price": 439 },
  { "name": "Nippon Baby Cricket Bat Ball Set", "price": 270 },
  { "name": "JRS AVS Tennis Bat with Ball", "price": 499 },
  { "name": "PMG Wooden Bat with Ball & Cap", "price": 499 },
  { "name": "Lifelong Poplar Wood Bat", "price": 1099 },
  { "name": "Toy Imagine Table Tennis Trainer", "price": 398 },
  { "name": "Ratna's Table Tennis Penguin Set", "price": 129 },
  { "name": "TIMA Hanging Leather Ball", "price": 309 },
  { "name": "Leader Sportz Foam Bat & Ball", "price": 741 },
  { "name": "HighRoof Plastic Cricket Kit", "price": 299 },
  { "name": "FELIDAE Bat + Wicket Set + Ball", "price": 699 },
  { "name": "TINEE Hula Hoop", "price": 299 },
  { "name": "PlayMagic Archery Set", "price": 597 },
  { "name": "BKDT Bowling Set with Pins & Balls", "price": 290 },
  { "name": "CrazyBuy Bouncing Moon Ball", "price": 243 },
  { "name": "Bestie Toys Bounce Ball", "price": 179 },
  { "name": "SR Toys Archery Kit", "price": 258 },
  { "name": "S TOYS HOUSE Archery Set", "price": 373 },
  { "name": "Tarak Spider-Man Bowling Set", "price": 344 },
  { "name": "Space Age Moon Ball Throwball", "price": 250 },
  { "name": "Ratnas Mickey Basketball", "price": 156 },
  { "name": "JASSIA RC Stunt Car Foosball", "price": 822 },
  { "name": "Giftoshopee Softball", "price": 140 },
  { "name": "333MART Big Bowling Game Set", "price": 1215 },
  { "name": "Aditi Toys Plastic Bowling Set", "price": 478 },
  { "name": "Toybharat Ping Pong Ball Set", "price": 353 },
  { "name": "SABIRAT Football Shoot & Score Kit", "price": 1498 },
  { "name": "Aditi Toys LED Bow & Arrow", "price": 666 },
  { "name": "Planet of Toys Heavy Duty Bow Set", "price": 500 },
    { "name": "Toys", "price": 600 },
    { "name": "Sports kit", "price": 2600 },
    { "name": "Gym item", "price": 1200 },
    { "name": "Games item", "price": 800 },
    { "name": "Other item", "price": 400 },


                  ],

   
  });

  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  


  const [shopName, setShopName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);
  const [gstRate, setGstRate] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [shareMethod, setShareMethod] = useState('');
  const [pdfFormat, setPdfFormat] = useState('default');


  const handleSearchChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
  
    const allItems = Object.entries(categories).flatMap(([category, items]) =>
      items.map(item => ({ ...item, category }))
    );
  
    const filtered = allItems.filter(item =>
      item.name.toLowerCase().includes(text.toLowerCase())
    );
  
    setSuggestions(filtered);
  };

  const handleSelectSuggestion = (item) => {
    const newItem = {
      name: item.name,
      price: item.price,
      quantity: 1,
      subtotal: item.price * 1,
    };
    setCart([...cart, newItem]);
    setSearchText('');
    setSuggestions([]);
  };

  const handleNewBill = () => {
    setShopName('');
    setGstNumber('');
    setPhoneNumber('');
    setSelectedCategory('');
    setSelectedItem('');
    setQuantity(1);
    setCart([]);
    setGstRate(0);
    setSearchText('');
    setSuggestions([]);
    setPdfFormat('default');
  };
  

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedItem('');
    setQuantity(1);
  };

  const handleItemChange = (event) => {
    setSelectedItem(event.target.value);
    setQuantity(1);
  };

  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };

  const handleAddItem = () => {
    const categoryItems = categories[selectedCategory];
    const item = categoryItems.find(i => i.name === selectedItem);
    if (item) {
      const newItem = {
        name: item.name,
        price: item.price,
        quantity: quantity,
        subtotal: item.price * quantity
      };
      setCart([...cart, newItem]);
      setSelectedItem('');
      setQuantity(1);
    }
  };

  const handleGstRateChange = (event) => {
    setGstRate(event.target.value);
  };

  const handlePriceChange = (index, event) => {
    const newCart = [...cart];
    newCart[index].price = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleQuantityEdit = (index, event) => {
    const newCart = [...cart];
    newCart[index].quantity = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleRemoveItem = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1); // Remove one item at the given index
    setCart(newCart);
  };
  
  const calculateTotal = () => {
    const subtotal = cart.reduce((acc, item) => acc + item.subtotal, 0);
    const gst = subtotal * (gstRate / 100);
    const total = subtotal + gst;
    return { subtotal, gst, total };
  };

  const generatePdfInvoice = () => {
    const total = calculateTotal();
    const currentDate = new Date().toLocaleDateString();
    const doc = new jsPDF();

    switch (pdfFormat) {
        case 'default':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'table':
            doc.autoTable({
                head: [[' Name', 'GST No', 'Phone Number', 'Date']],
                body: [[shopName, gstNumber, phoneNumber, currentDate]],
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'blueBlack':
            doc.setTextColor(0, 0, 255);
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.setTextColor(0, 0, 0);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'professionalGrid':
            doc.setFontSize(18);
            doc.text(shopName, 10, 10);
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 10, 20);
            doc.text(`Date: ${currentDate}`, 10, 30);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                theme: 'grid',
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                theme: 'grid',
            });
            break;

        case 'compactSummary':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

            
                case 'classicTable':
                    doc.setFontSize(20);
                    doc.text(shopName, 105, 15, null, null, 'center');
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
                    doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
                    doc.setFontSize(16);
                    doc.text('Invoice', 105, 30, null, null, 'center');
                    doc.autoTable({
                        startY: 40,
                        head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                        body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                    });
                    break;
        
                case 'boxedLayout':
                    doc.setFontSize(20);
                    doc.text(shopName, 10, 10);
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 10, 20);
                    doc.text(`Date: ${currentDate}`, 10, 30);
                    doc.autoTable({
                        startY: 40,
                        head: [['Item', 'Price', 'Quantity', 'Subtotal']],
                        body: cart.map((item) => [item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0], lineWidth: 0.5 },
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                        styles: { fillColor: [0, 180, 0], textColor: [0, 0, 0] },
                    });
            break;   
            
            

        case 'modernMinimalist':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity(Kg/ltr/each', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            break;

        case 'elegantLines':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            break;

        case 'detailedSections':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Section', 'Details']],
                body: [
                    ['Shop Details', `${shopName}, GST No: ${gstNumber}, Date: ${currentDate}`],
                    ['Items', cart.map((item) => `Name: ${item.name}, Quantity: ${item.quantity}, Subtotal: ${item.subtotal.toFixed(2)}`).join('; ')],
                    ['Totals', `Subtotal: ${total.subtotal.toFixed(2)}, GST: ${total.gst.toFixed(2)}, Total: ${total.total.toFixed(2)}`],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.5 },
            });
            break;

        

        default:
            break;
    }

    // Save the PDF to Blob
    const pdfBlob = doc.output('blob');

    // Share to WhatsApp
    const shareToWhatsApp = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(whatsappUrl, '_blank');
    };

    // Share to Email
    const shareToEmail = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const mailtoUrl = `mailto:?subject=Your Invoice&body=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(mailtoUrl, '_blank');
    };

    // Share the PDF as needed
    if (shareMethod === 'whatsapp') {
        shareToWhatsApp();
    } else if (shareMethod === 'mail') {
        shareToEmail();
    }

    // Save the PDF
    //doc.save('invoice.pdf');
    doc.save(`${shopName +'-invoice' || 'invoice'}.pdf`);

};


  const handleShare = (method) => {
    setShareMethod(method); // Set the sharing method
    const shareText = `Shop Name: ${shopName}\nGST No: ${gstNumber}\nPhone Number: ${phoneNumber}`;

    if (method === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(shareText)}`);
    } else if (method === 'mail') {
      window.open(`mailto:?subject=MarketApp%20Details&body=${encodeURIComponent(shareText)}`);
    }

    setShowModal(false); // Close modal after sharing
  };

  const handleGenerateAndShare = () => {
    generatePdfInvoice();
    setShowModal(true); // Show modal after generating PDF
  };

  const handleFormatChange = (e) => {
    setPdfFormat(e.target.value); // Set the PDF format
};

const formatOptions = [
    { value: 'default', label: 'Default' },
    { value: 'table', label: 'Table Format' },
    { value: 'blueBlack', label: 'Blue and Black' },
    { value: 'professionalGrid', label: 'Professional Grid' },
    { value: 'compactSummary', label: 'Compact Summary' },
    { value: 'classicTable', label: 'Classic Table' },
    { value: 'boxedLayout', label: 'Boxed Layout' },
    { value: 'modernMinimalist', label: 'Modern Minimalist' },
    { value: 'elegantLines', label: 'Elegant Lines' },
    { value: 'detailedSections', label: 'Detailed Sections' },
    
];


return (
    <div className="MarketApp">
       <img src="./Images/jalm.png" alt="Just A Little Market" width="100" height="100" />
      <h1><u>Stationary & Gift Store</u></h1>

<div style={{ marginTop: '20px', textAlign: 'left', paddingLeft: '10px' }}>
  <button
    onClick={handleNewBill}
    style={{
      backgroundColor: '#007bff',
      color: '#fff',
      padding: '12px 20px',
      fontSize: '18px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 123, 255, 0.3)',
      transition: 'background-color 0.3s ease, transform 0.2s ease'
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = '#0056b3';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = '#007bff';
      e.target.style.transform = 'scale(1)';
    }}
  >
    🧾 New Bill
  </button>
</div>
<br/>

  
      {/* Shop Info */}
  
    <div className="container">
  {/* Responsive Input Section */}
  <div className="input-section">
    <div className="form-group">
      <label>Store/Shop Name:</label>
      <input type="text" value={shopName} onChange={(e) => setShopName(e.target.value)} />
    </div>

    <div className="form-group">
      <label>GST No:</label>
      <input type="text" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Phone Number:</label>
      <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Search Items:</label>
      <input
        type="text"
        value={searchText}
        onChange={handleSearchChange}
        placeholder="Type to search..."
      />
      {suggestions.length > 0 && (
        <ul className="suggestion-list">
          {suggestions.map((item, idx) => (
            <li key={idx} onClick={() => handleSelectSuggestion(item)}>
              {item.name} — ₹{item.price} <span className="category">({item.category})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>

  {/* Category Selection */}
  <div className="form-group">
    <label>Select Category:</label>
    <select onChange={handleCategoryChange} value={selectedCategory}>
      <option value="" disabled>Select a category</option>
      {Object.keys(categories).map((cat, i) => (
        <option key={i} value={cat}>{cat}</option>
      ))}
    </select>
  </div>

  {selectedCategory && (
    <>
      <div className="form-group">
        <label>Select Item:</label>
        <select onChange={handleItemChange} value={selectedItem}>
          <option value="" disabled>Select an item</option>
          {categories[selectedCategory].map((item, i) => (
            <option key={i} value={item.name}>{item.name}</option>
          ))}
        </select>
      </div>

      {selectedItem && (
        <>
          <div className="form-group">
            <label>Quantity:</label>
            <input type="number" value={quantity} onChange={handleQuantityChange} min="1" />
          </div>
          <div className="form-group">
            <button onClick={handleAddItem}>Add Item</button>
          </div>
        </>
      )}
    </>
  )}

  {/* Cart Table */}
  <div className="cart-section">
    <h2>Cart</h2>
    {cart.length === 0 ? (
      <p>No items added.</p>
    ) : (
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Subtotal</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) => handlePriceChange(index, e)}
                    min="0"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleQuantityEdit(index, e)}
                    min="1"
                  />
                </td>
                <td>{item.subtotal.toFixed(2)}</td>
                <td><button onClick={() => handleRemoveItem(index)}>Remove</button></td>
              </tr>
            ))}
            <tr>
              <td colSpan="3">Subtotal</td>
              <td>{calculateTotal().subtotal.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">
                GST Rate:
                <select onChange={handleGstRateChange} value={gstRate}>
                  <option value="0">0%</option>
                  <option value="5">5%</option>
                  <option value="6">6%</option>
                  <option value="9">9%</option>
                  <option value="18">18%</option>
                </select>
              </td>
              <td>{calculateTotal().gst.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">Total</td>
              <td>{calculateTotal().total.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )}
  </div>

  {/* PDF Section */}
{cart.length > 0 && (
 
  <div className="pdf-section" style={{
    marginTop: '30px',
    padding: '20px',
    backgroundColor: '#f1f3f5',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  }}>
    <label style={{
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333'
    }}>
      🧾 Select Invoice Format:
    </label>

    <select
      onChange={handleFormatChange}
      value={pdfFormat}
      style={{
        padding: '10px',
        fontSize: '16px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      {formatOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>

    <button
      onClick={handleGenerateAndShare}
      style={{
        backgroundColor: '#007bff',
        color: '#fff',
        padding: '14px',
        fontSize: '17px',
        fontWeight: '600',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,123,255,0.3)',
        transition: 'transform 0.2s ease, background-color 0.3s ease'
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = '#0056b3';
        e.target.style.transform = 'scale(1.05)';
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = '#007bff';
        e.target.style.transform = 'scale(1)';
      }}
    >
      📄 Generate PDF Invoice
    </button>
  </div>
)}


<br /><br />

 

</div>

 </div>   
  ); // ✅ this closes the return statement
  
  
}

export default Stationary;
  


  

